export default {
  "100_items_page": "100條/頁",
  "10_items_page": "10條/頁",
  "50_items_page": "50條/頁",
  abandon_editing: "",
  abbreviation: "",
  abbreviation_cannot_be_empty: "",
  abbreviation_must_be_letters_or_numbers_and_no_longer_than_8_cha: "",
  abnormal: "異常",
  abnormal_behavior_monitoring: "",
  abnormal_cage_layer: "",
  abnormal_chicken_cage_statistics: "",
  abnormal_file: "",
  abnormal_network: "",
  abnormal_pig_behavior_alarm: "",
  abnormal_pig_count_heads: "",
  abnormal_pig_quantity_alarm: "",
  abnormal_points: "",
  abnormal_quantity: "",
  abnormal_robot_restart: "",
  abnormal_video_file_pls_confirm: "所選錄像檔異常，請確認！",
  abn_cage: "",
  about: "關於",
  about_the_device: "",
  above_alarm: "高溫報警",
  above_alarm_temp_below_alarm_temp: "高溫報警溫度值需大於低溫報警溫度值",
  above_isotherm: "等溫線上",
  accelerate: "加速",
  accessories: "",
  access_channel_quantity_limit: "接入通道數量限制",
  access_control_device: "門禁設備",
  access_control_terminal: "面板機",
  access_to_location_information_required_to_obtain_gps_data: "",
  account: "",
  account_format_allows_letters_or_numbers_only: "",
  account_format_should_be_letters_or_numbers_and_length_should_no: "",
  account_is_locked_unlocked_after_10_minutes: "帳戶已鎖定,10分鐘後解鎖",
  account_login: "賬號登錄",
  account_management: "",
  account_must_be_numbers_or_chinese_characters_and_no_longer_than: "",
  account_not_exist: "",
  account_password_modification: "",
  acrel: "安科瑞",
  actual_alarm_reason: "",
  actual_payments: "",
  actual_time: "實際時間",
  add: "添加",
  added: "已添加",
  added_successfully: "新增成功",
  added_to_cloud: "添加到雲平臺",
  added_to_download_queue: "",
  adding_mode: "添加方式",
  adding_patrol_plan_failed: "添加輪訓計畫失敗",
  adding_patrol_plan_succeeded: "添加輪巡計畫成功",
  adding_qr_code_points_is_not_allowed: "",
  adding_recording_lock_failed: "添加錄影鎖定失敗",
  adding_recording_lock_failed_conflicts_with_existing_recording_l:
    "添加錄影鎖定失敗，與現有錄影鎖定時間有交集",
  adding_recording_lock_succeeded: "添加錄影鎖定成功",
  adding_recording_plan_failed: "添加錄影計畫失敗",
  adding_recording_plan_succeeded: "添加錄影計畫成功",
  address: "地址",
  addr_manage: "",
  add_address: "",
  add_area: "新增區域",
  add_associated_group: "新增關聯組",
  add_channels: "添加通道",
  add_company_information: "",
  add_curve: "添加曲線",
  add_data_permi: "",
  add_department: "",
  add_device: "添加設備",
  add_email: "新增郵箱",
  add_failed: "添加失敗",
  add_img: "添加圖片",
  add_inspection_point: "",
  add_manually: "手動添加",
  add_manufacturer: "",
  add_map: "",
  add_new_cage_position: "",
  add_new_point: "",
  add_new_shipping_address: "",
  add_patrol: "添加輪巡",
  add_point: "",
  add_push_notification_personnel: "新增推送人員",
  add_res: "添加資源",
  add_resource: "新增資源",
  add_res_type: "添加資源類型",
  add_robot: "",
  add_row: "添加行",
  add_rule: "添加規則",
  add_shielded_area: "新增屏蔽區域",
  add_spin_drift_to_results: "將自旋漂移添加到結果中",
  add_successful: "添加成功",
  add_temp_difference_rule: "新增差值測溫規則",
  add_temp_range: "增加溫度範圍",
  add_to_cart: "",
  add_to_cloud_success: "添加到雲平臺成功",
  add_user: "",
  add_video: "添加視頻",
  add_views: "添加視圖",
  add_your_dedicated_engineer: "添加您的專屬工程師",
  adjust_line_number: "",
  adjust_order: "",
  adjust_volume_brightness_through_device_buttons: "",
  admin: "超級管理員",
  administrative_region_vector_layer: "行政區域向量圖層",
  administrator_management: "",
  admin_account: "",
  admin_account_cannot_be_empty: "",
  admin_account_must_be_letters_or_numbers_and_no_longer_than_20_c: "",
  admin_cannot_be_deld: "管理員不可以刪除",
  advance: "高級",
  advanced: "高級設置",
  ad_domain_login: "AD域登錄",
  after_enabling_thermal_imgs_will_be_automatically_captured_when_:
    "開啟後，報警發生時會自動抓拍熱像圖",
  after_locking_the_robot_will_only_stay_in_place_and_will_not_per: "",
  after_logging_out_the_info_related:
    "注销后，账号相关的信息都会从系统移除，请谨慎操作",
  after_sales_service: "",
  after_successfully_modifying_the_wifi_information_you_need_to_re: "",
  after_switching_the_false_alarm_filtering_switch_the_fire_inform:
    "切換誤報過濾開關後，將清空右上角火情消息，確定切換嗎？",
  after_the_channel_is_seled_the_channel_info_including_video_prev:
    "勾選後，平臺可以查看該通道資訊，包括即時預覽、錄影重播、錄影計畫、業務報警查看、設備報警查看等",
  after_the_wifi_name_is_modified_you_need_to_reconnect_the_device:
    "修改後需要重新連接設備WiFi",
  after_unlocking_the_robot_will_perform_preset_inspection_tasks: "",
  agent: "",
  agent_cannot_be_empty: "",
  age_in_days: "",
  agree: "同意",
  agreement: "協定",
  air_pressure: "",
  ais_layer: "AIS圖層",
  ai_analysis_basis: "AI研判依據",
  ai_result_display: "",
  alarm: "報警",
  alarms_with_repeated_occurrences_equal_to_or_less_than_this_thre:
    "重複報警次數小於等於該閾值的報警將被過濾",
  alarm_analysis: "",
  alarm_area: "報警區域",
  alarm_attributes: "報警屬性",
  alarm_auto_photo: "報警自動拍照",
  alarm_category: "報警分類",
  alarm_center: "報警中心",
  alarm_condition: "報警條件",
  alarm_config: "",
  alarm_count: "",
  alarm_count_threshold_times: "報警次數閾值（次）",
  alarm_description: "",
  alarm_details: "報警詳情",
  alarm_device: "報警設備",
  alarm_enable_time: "",
  alarm_end_time: "報警結束時間",
  alarm_events: "",
  alarm_filter_duration_s: "報警過濾時長(s)",
  alarm_filter_time: "(報警)過濾時間",
  alarm_handling: "",
  alarm_handling_time: "",
  alarm_high_low_temp: "高低溫報警",
  alarm_history: "歷史報警",
  alarm_information: "報警信息",
  alarm_information_query_alm_info_qry: "告警資訊查詢",
  alarm_input: "報警輸入",
  alarm_in_progress: "報警中",
  alarm_item: "",
  alarm_item_config: "",
  alarm_layer: "報警圖層",
  alarm_level: "報警級別",
  alarm_linkage: "報警聯動",
  alarm_management: "",
  alarm_name: "報警名稱",
  alarm_occurred_times: "",
  alarm_on_off: "報警開關",
  alarm_points: "",
  alarm_preview: "",
  alarm_processing: "報警處理",
  alarm_processing_template: "報警處理模板",
  alarm_prompt_control: "報警提示控制",
  alarm_query_aq: "告警查詢",
  alarm_query_failed: "報警查詢失敗",
  alarm_record: "事件記錄",
  alarm_record_handling: "",
  alarm_region_setting: "報警區域設置",
  alarm_report: "",
  alarm_result: "",
  alarm_result_details: "",
  alarm_result_storage_time: "",
  alarm_retrieval: "",
  alarm_sensitivity: "",
  alarm_settings: "報警設置",
  alarm_shielding_rule_settings: "報警遮罩規則設置",
  alarm_snapshot: "報警抓拍",
  alarm_snapshot_completed: "報警抓拍完成",
  alarm_snapshot_interrupted: "報警抓拍已中斷",
  alarm_snapshot_in_progress: "報警抓拍中",
  alarm_sound: "",
  alarm_source: "報警源",
  alarm_source_name: "報警源名稱",
  alarm_start_time: "報警開始時間",
  alarm_statistics: "",
  alarm_status: "",
  alarm_strategy: "",
  alarm_table: "報警報表",
  alarm_template: "報警範本",
  alarm_temp_setting: "報警溫度設定",
  alarm_threshold: "報警閾值",
  alarm_time: "報警時間",
  alarm_trigger_time: "",
  alarm_type: "報警類型",
  alarm_viewing: "",
  album: "相簿",
  algorithm_alarm: "演算法報警",
  algorithm_information_not_configured: "未配置演算法資訊",
  algorithm_name: "演算法名稱",
  algorithm_operating_channel: "演算法運行通道",
  algorithm_recognition: "",
  algorithm_recognition_failed: "",
  algorithm_syncing: "",
  algorithm_type_cannot_be_empty: "演算法類型不能為空",
  algorithm_ver_number: "",
  alg_op_plan: "演算法運行計畫",
  alignment_distance: "對齊距離",
  align_style_setting: "對齊樣式設置",
  alipay: "",
  aliyuncom: "阿裡雲",
  all: "全部",
  allow_input_of_1_to_20_characters_which_can_be_numbers_letters_o:
    "允許輸入1~20位的數字、字母、-、_",
  all_alarm_areas_have_been_cleared: "所有報警區域已清空",
  all_anomalies: "",
  all_appraise: "",
  all_coops: "",
  all_day: "",
  all_day_alarm: "",
  all_devices: "",
  all_order: "",
  all_seled_files_have_been_downloaded: "",
  all_shared_channels_of_the_platform_will_be_cleared:
    "平臺已共享通道將全部清空",
  already_alarmed: "",
  already_latest_ver: "已是最新版本",
  already_synchronized: "",
  altitude: "海拔",
  ammonia: "",
  amplify: "放大",
  analysis_settings: "分析設置",
  analyze: "分析",
  analyzed: "",
  analyze_all: "分析全部素材",
  angle: "",
  angle_restricted_to_integers_in_the_range_90_90: "",
  animal_warning: "",
  anomalies_in_ope_pls_try_again: "異常操作，請重試",
  anomalies_in_points_need_to_retrieve_them_from_the_platform: "",
  anonymity: "",
  another_user_is_currently_operating_pls_try_again_later:
    "其他用戶正在操作，請稍後重試",
  an_error_occurred: "",
  an_existing_device_is_currently_connected_pls_wait:
    "已有設備處於連接狀態，請等待",
  api_interface_timeout: "",
  application: "應用",
  application_exception: "應用異常",
  application_name: "",
  application_restart: "",
  application_status: "應用狀態",
  application_system_alarm: "應用系統報警",
  application_ver: "",
  applied_fov: "應用視場角",
  applying_for_memory_permission: "申請記憶體許可權",
  appraise: "",
  app_binding_status: "app綁定狀態",
  app_ver: "",
  apr: "四月",
  arctic: "",
  area_intrusion: "區域入侵",
  area_name_cannot_be_empty: "區域名不能為空",
  are_there_other_hotspots_with_the_same_name_around_the_device: "",
  are_you_sure_to_clear_all_area_rules_for_the_current_device:
    "確定要清空當前型號設備的所有區域規則？",
  are_you_sure_to_del_the_n1_inspection_task: "",
  are_you_sure_to_del_the_template: "是否刪除模板",
  are_you_sure_to_del_this_resource: "確定刪除該資源嗎?",
  are_you_sure_to_del_this_resource_type: "確定刪除該資源類型嗎?",
  are_you_sure_to_del_this_shieled_area: "確定刪除該屏蔽區域嗎？",
  are_you_sure_to_del_this_will_affect_historical_information_view:
    "確定進行刪除操作? (將影響設備即時預覽、錄影重播、錄影計畫、報警記錄、測溫資料的歷史資訊查看)",
  are_you_sure_to_exit: "是否確認退出",
  are_you_sure_you_want_to_del_the_data_item_named_n1: "",
  are_you_sure_you_want_to_del_the_data_item_with_resource_id_x: "",
  are_you_sure_you_want_to_del_the_line: "",
  are_you_sure_you_want_to_del_the_seled_report: "",
  are_you_sure_you_want_to_del_this_config: "",
  are_you_sure_you_want_to_exit: "",
  are_you_sure_you_want_to_exit_exiting_will_disable_the_alarm_lin:
    "是否確認退出？退出後會關閉報警聯動",
  are_you_sure_you_want_to_export_all_data_permi_items: "",
  are_you_sure_you_want_to_restart_the_robot: "",
  are_you_sure_you_want_to_resume_re_execute_the_xxx_inspection_ta: "",
  are_you_sure_you_want_to_resume_the_n1_inspection_task: "",
  are_you_sure_you_want_to_re_execute_the_n1_inspection_task: "",
  are_you_sure_you_want_to_terminate_the_n1_inspection_task: "",
  array_size: "陣列規模",
  asbestos_board: "石棉板",
  ascending: "",
  ascending_order_by_name: "按名稱昇冪",
  ascending_order_by_time: "按時間昇冪",
  associated_cage_number: "",
  associated_channel: "關聯通道",
  associated_channel_cannot_be_empty: "關聯通道不能為空",
  associated_code: "對應編碼",
  associated_column_number: "",
  associated_component: "對應組件",
  associated_component_eg_menu: "對應組件,如Menu",
  associated_group: "關聯組",
  associated_group_identifier_cannot_be_empty: "關聯組標識不能為空",
  associated_group_names_cannot_be_duplicated: "關聯組名稱不可重複",
  associated_group_name_length_cannot_exceed: "關聯組名稱長度不能超過",
  associated_img_capture_direction: "",
  associated_map: "",
  associated_organization: "",
  associated_point: "",
  associated_robot: "",
  associated_task: "",
  associate_ir_img: "關聯紅外圖片",
  associate_region: "關聯區域",
  association_name: "關聯名稱",
  association_successful: "",
  asynchronous: "",
  asynchronously_starting_recording_plan: "非同步啟動錄影計畫",
  atmospheric_ambient_temp: "大氣環境溫度",
  atmospheric_temp_is_out_of_range: "環境溫度超出範圍",
  atmospheric_temp_is_required: "環境溫度不能為空",
  atmospheric_transmissivity: "大氣透過率",
  atmos_temp: "環境溫度",
  attribute: "屬性",
  at_least_one_comprehensive_judgment_rule_must_be_seled:
    "綜合研判規則至少選一項",
  audio: "聲音",
  aug: "八月",
  authentication: "認證",
  authentication_failed_and_the_upload_was_terminated: "鑑權失敗,上傳終止",
  authorization_successful: "授權成功",
  authorization_successfully_revoked: "",
  authorize: "",
  authorize_use_of_robot_ope_information: "",
  auth_failed: "認證失敗",
  auth_failed_app_will_exit: "認證失敗，應用即將退出。",
  auth_failed_incorrect_username_password_or_device_model:
    "認證失敗，用戶名、密碼或設備型號錯誤",
  auto: "自動",
  autofocus_core_the_blackbody_temp_x_10:
    "說明：有自動聚焦功能的機芯，黑體溫度值乘10",
  automatically_turn_off_io: "自動關閉報警",
  automatic_blinding_succeeded: "",
  automatic_gain: "自動增益",
  automatic_time_synchronization: "自動校時",
  automatic_tracking_is_not_possible_pls_switch_the_linkage_contro:
    "無法進行自動追蹤，請將設備聯動控製切換至自動跟隨模式。",
  automobile_night_vision: "",
  auto_0: "自動調整0",
  auto_brightness_adjustment: "",
  auto_change_gain_mode: "(ATU)自動切換增益",
  auto_cloud_connection_successful: "",
  auto_excl: "自動剔除",
  auto_excl_speed: "自動剔除速度",
  auto_focus: "自動聚焦",
  auto_login: "自動登錄",
  auto_mode: "",
  auto_mode_restoration_time: "",
  auto_power_off: "自動關機",
  auto_save: "自動保存",
  auto_temp_scale_enabled: "",
  auto_time_sync_set_successfully: "",
  average: "",
  average_egg_production: "",
  average_egg_production_rate: "",
  average_temp: "平均溫度",
  average_temp_equal_to: "平均溫等於",
  average_weight: "",
  average_weight_per_pig: "",
  avg: "平均溫",
  avg_temp_big_than: "平均溫大於",
  avg_temp_less_than: "平均溫小於",
  axis: "安讯士",
  azimuth_angle: "",
  a_channel_cannot_belong_to_multiple_associated_groups_whether_as:
    "一個通道不能從屬於多個關聯組。同一個關聯組內，關聯通道是否同時報警，將作為綜合研判去誤報的參考。",
  a_file_is_being_downloaded_pls_confirm_whether_to_modify_the_enc: "",
  a_file_is_being_downloaded_pls_confirm_whether_to_modify_the_pwd: "",
  a_file_is_being_downloaded_pls_confirm_whether_to_modify_the_wif: "",
  a_locked_robot_cannot_execute_inspection_tasks_as_planned_confir: "",
  a_max_of_6_video_streams_can_be_displayed_at_most: "最多只能展示6路視頻",
  a_max_of_n_target_points_are_allowed: "最多允許添加{n}個目標點",
  a_max_of_n_videos_can_be_displayed: "最多只能展示{n}路視頻",
  a_quick_report_is_created_pls_wait: "一個快速報告任務正在進行，請稍等",
  a_window: "一個視窗",
  background_api_ver: "",
  back_to_home_page: "",
  back_to_ir_searcher_app: "",
  back_to_the_previous_menu: "返回上一級",
  ballistics: "",
  ballistic_calculation: "",
  ballistic_coefficient: "",
  bark: "樹皮",
  base_map: "底圖",
  base_map_control: "底圖控製",
  base_map_transparency: "底圖透明度",
  basic_info: "基礎資訊",
  basic_information: "",
  basic_information_config: "",
  basic_setting: "基礎設置",
  batch_add: "批量添加",
  batch_create: "",
  batch_delete: "批量刪除",
  batch_dl: "批量下載",
  batch_download_logs: "",
  batch_import: "批量導入",
  batch_remove: "批量移除",
  batch_revoke_authorization: "",
  batch_settings: "批量設置",
  batch_sync: "",
  batch_unbind: "批量解綁",
  battery: "",
  battery_abnormal: "",
  battery_alarm_threshold: "",
  battery_capacity: "電池容量",
  battery_current: "",
  battery_information: "",
  battery_is_low_and_will_be_shut_down_soon: "電池電量不足，即將關機",
  battery_level: "",
  battery_life: "",
  battery_model: "",
  battery_status: "",
  battery_temp: "",
  battery_type: "",
  battery_voltage: "",
  baud_rate: "串列傳輸速率",
  below_alarm: "低溫報警",
  below_alarm_temp_above_alarm_temp: "低溫報警溫度值需小於高溫報警溫度值",
  below_isotherm: "等溫線下",
  beta: "內測版本",
  beyond_range: "",
  bill_management: "",
  binding_now: "",
  bind_app: "綁定app",
  bind_now: "",
  bird: "",
  black_body_temp: "黑體溫度",
  black_hot: "黑熱",
  black_or_white_paint: "黑或白漆",
  blank_page: "空白頁面",
  blind_element_settings_saved_successfully: "",
  blind_element_setting_mode: "",
  blind_element_setting_mode_has_exited: "",
  blind_spot_radius: "盲區半徑",
  blink: "閃爍",
  blocked: "",
  blue: "藍",
  bluehot: "藍熱",
  bluetooth_authorization_is_required_to_discover_new_devices:
    "需要開啟藍牙授權才能發現新設備",
  bluetooth_device_disconnected: "",
  bluetooth_device_not_found_yet: "",
  bluetooth_permi_required: "",
  blue_shades: "漸變藍",
  boat_with_ais: "有AIS船隻",
  bottom_left: "左下",
  bottom_right: "右下",
  bound: "已綁定",
  bound_rebind: "已綁定,換綁",
  brass_mirror: "黃銅鏡面",
  brass_oxide: "氧化黃銅",
  brazilian_portuguese: "巴葡語",
  brightness: "亮度",
  brightness_adjustment: "",
  brightness_settings: "",
  bright_black_paint: "黑亮漆(噴在粗糙鐵上)",
  bright_paint: "亮漆(所有顏色)",
  broadcast_lan: "播放語言",
  browser_time: "",
  browsing_history: "",
  building_details: "",
  building_name: "",
  building_statistics: "",
  built_in_firmware_ver_number: "",
  bullet: "",
  bullet_camera: "槍機",
  bullet_diameter: "",
  bullet_information: "",
  bullet_length: "",
  bullet_list: "",
  bullet_manufacturer: "",
  bullet_name_already_exists_pls_edit_again: "",
  bullet_weight: "",
  business_alarm: "",
  business_alarm_email_subject: "【系統通知】業務報警統計通知",
  business_execution_error: "業務執行出錯",
  button_settings: "",
  buy_now: "",
  by_count: "",
  by_day: "按天",
  by_frequency: "",
  by_hour: "按時",
  by_level: "按等級",
  by_minute: "按分",
  by_month: "按月",
  by_name: "按名稱",
  by_organization_structure: "按組織結構",
  by_second: "按秒",
  by_threshold: "按閾值",
  by_time: "按時間",
  by_week: "按周",
  by_year: "按年",
  cage: "",
  cage_name: "",
  cage_no: "",
  cage_view: "",
  calcimine: "牆粉",
  calibrate: "標定",
  calibrated: "已校準",
  calibrate_device: "校準設備",
  calibrate_failed: "標定失敗",
  calibrate_succeeded: "標定成功",
  calibration: "校準",
  calibration_method: "標定方法",
  calibration_status: "校準狀態",
  camera: "",
  camera_ip: "",
  camera_ip_left: "",
  camera_ip_right: "",
  camera_name: "",
  camera_name_left: "",
  camera_permi_required: "",
  camera_permi_required_to_accurately_obtain_azimuth_information: "",
  camera_status: "",
  camera_status_left: "",
  camera_status_right: "",
  camera_type: "",
  camera_type_right: "",
  cancel: "取消",
  canceled: "",
  cancel_download: "",
  cancel_search: "取消搜索",
  cancel_sel: "",
  cancel_the_download: "",
  cannot_be_greater_than_the_max_val: "",
  cannot_be_less_than_the_min_val: "",
  cannot_duplicate_with_other_rules: "不可與其他規則重複",
  cannot_sel_two_constants_at_the_same_time: "不能同時選擇兩個常量",
  can_be_purchased_after_login_auth: "",
  can_not_join_group_shop_from_cart: "",
  capacity: "容量",
  capacity_is_less_than_200_mb: "Sd卡剩餘空間不足200M,錄製終止!",
  capacity_is_less_than_200_mb_cannot_recording:
    "Sd卡剩餘空間不足200M,錄製終止",
  caps_lock_is_on: "大寫鎖定已打開",
  capture_time: "",
  car: "汽車",
  carbon_dioxide: "",
  carbon_dioxide_cloud_map: "",
  carbon_dioxide_concentration: "",
  carbon_dioxide_ppm: "",
  carbon_dioxide_sensor_status: "",
  carbon_monoxide: "一氧化碳",
  carbon_plate: "碳片",
  cargo_ship: "貨船",
  cart: "",
  category: "",
  category_cannot_be_empty: "",
  category_featured: "",
  celsius: "攝氏度",
  center_ip: "中心IP",
  center_port: "中心端口",
  center_spot: "中心點",
  certificated: "",
  certificate_information_retrieval_error_pls_contact_the_administ:
    "證書信息獲取錯誤，請聯系管理員",
  certificate_installation_error_pls_contact_the_administrator:
    "證書安裝錯誤，請聯系管理員",
  certificate_must_be_in_lic_format: "證書只能是 .lic 格式",
  certificate_verification_failed: "",
  change_avatar: "",
  change_bound_phone_number: "",
  change_from_0_to_1: "從{0}變到{1}",
  channel: "通道",
  channels: "個通道",
  channels_not_shared: "未共享通道",
  channel_addition_exception: "添加通道異常",
  channel_data_does_not_exist: "通道資料不存在",
  channel_does_not_exist: "",
  channel_id: "通道編號",
  channel_information: "通道資訊",
  channel_no: "通道數",
  channel_not_found_in_the_platform: "平臺內沒有添加該通道",
  channel_no_is_required: "通道數不能為空",
  channel_number: "",
  channel_offline: "通道離線",
  channel_type: "通道類型",
  chan_id: "通道ID",
  chan_name: "通道名稱",
  charging: "",
  charging_point: "",
  charging_points: "",
  chars_less_than: "字元數小於",
  chart_combination_of_numbers_capital_and_lowercase: "",
  chassis: "",
  chassis_malfunction: "",
  checking: "校驗中",
  check_for_updates: "檢查更新",
  check_if_its_the_device_network: "檢查是否是設備網路",
  chicken_cage: "",
  chicken_coop: "",
  chicken_coop_management: "",
  chicken_mouth_open_alarm: "",
  chicken_recognition: "",
  china_bright: "瓷器(亮)",
  chinese_characters_not_permitted: "密碼不能包含中文",
  choose_bullet: "",
  choose_every_time: "每次選擇",
  choose_firearm: "",
  choose_from_the_dropdown_list_do_not_copy_and_paste_from_other_f:
    "下拉選擇，請勿從其他文件複製粘貼",
  circle: "圓",
  city: "城市",
  clean_up_alarm_interval: "清理報警數據間隔",
  clean_up_by_space: "",
  clean_up_temp_interval: "清理溫度數據間隔",
  clear: "清空",
  clear_cache: "",
  clear_calibration_failed: "清除標定失敗",
  clear_calibration_succeeded: "清除標定成功",
  clear_cart: "",
  clear_model_information: "清除型號資訊",
  clear_successful: "清除成功",
  clicks: "",
  click_on_the_map_to_retrieve_information_from_any_location:
    "點擊地圖任一位置獲取",
  click_resource_to_see_detail_infomation: "點擊素材查看詳情",
  click_to_sel_alarm_source: "點擊選擇報警源",
  click_to_sel_export_information: "點擊選擇匯出資訊",
  click_to_sel_parent_directory: "點擊選擇上級目錄",
  click_to_upload: "",
  click_to_upload_avatar: "",
  click_to_view: "",
  clip: "裁剪",
  clip_failed: "裁剪失敗",
  clip_success: "裁剪成功",
  clockwise: "順時針",
  clockwise_deviation_from_due_north_angle: "順時針偏離正北",
  close: "關閉",
  close_all: "關閉所有",
  close_all_playback: "關閉全部重播",
  close_distance_highlight: "",
  close_distance_highlight_display: "",
  close_distance_pedestrian_warning: "",
  close_distance_vehicle_warning: "",
  close_factory_password: "",
  close_playback: "關閉重播",
  close_prompt: "關閉提示",
  close_video: "關閉視頻",
  closing_pls_wait: "關閉中，請稍候...",
  cloud: "雲平臺",
  cloud_connection_successful: "",
  cloud_download: "雲端下載",
  cloud_import: "雲端導入",
  cloud_import_directory: "雲端導入路徑",
  cloud_login: "雲平臺登錄",
  cloud_platform_connection_failed: "",
  cloud_platform_connection_successful: "",
  cloud_platform_settings: "",
  cloud_resource: "雲端資源庫",
  cloud_status: "雲端狀態",
  cloud_user: "雲平臺用戶",
  coarse_tuning: "粗調",
  cold_spot: "冷點追踪",
  collect_interval: "採集間隔",
  color: "",
  color_highlights: "顏色凸顯",
  color_palette: "偽彩",
  column_cage_layer_suspected_discovery: "",
  column_name: "",
  column_x_cage_x_layer_x: "",
  commodity_amount: "",
  communication_status: "",
  company_n: "公司名稱",
  compiled_ver_number: "",
  complete: "完成",
  composite_report: "合成報告",
  comprehensive_analysis_basis: "綜合研判依據",
  comprehensive_intelligent_analysis_level: "智能綜合研判等級",
  com_is_required: "COM不能為空",
  concrete: "混凝土",
  config: "配置",
  configure_device_wifi: "",
  configure_rules: "配置規則",
  configure_storage_strategy: "設置存儲策略",
  config_not_supported: "不支持配置。",
  config_region: "配置區域",
  config_tool: "配置工具",
  config_tool_is_running: "配置工具已運行。",
  confirm: "",
  confirmed: "",
  confirm_and_continue: "確認並繼續",
  confirm_clearing_all_map_markers: "確定清空所有的地圖標注？",
  confirm_deletion: "",
  confirm_deletion_of_xxx_inspection_task: "",
  confirm_intelligent_import_ope: "確定進行智能導入操作?",
  confirm_its_an_anomaly: "",
  confirm_its_a_false_alarm: "",
  confirm_logout: "",
  confirm_log_in_again: "",
  confirm_new_password: "",
  confirm_or_not: "是否確認",
  confirm_permanent_deletion_this_action_is_not_recoverable: "",
  confirm_pwd: "確認密碼",
  confirm_restore_default_ope: "確定進行恢復默認操作",
  confirm_stopping_device_alarm: "確定停止設備報警",
  confirm_termination_of_xxx_inspection_task: "",
  confirm_the_cull_after_culling_the_target_will_no_longer_be_dete:
    "確認剔除嗎?剔除後將不再檢測該目標。",
  confirm_the_unbinding_ope: "確定進行解綁操作",
  confirm_to_del: "確定刪除",
  confirm_to_delrobot: "",
  confirm_to_deltenant: "",
  confirm_to_del_all_regions: "確認刪除所有區域嗎",
  confirm_to_del_the_cur_path: "確認移除當前路徑嗎",
  confirm_to_del_the_file: "是否確認刪除檔",
  confirm_to_del_the_selected_file: "",
  confirm_to_del_this_chicken_house: "",
  confirm_to_del_this_pig_house: "",
  confirm_to_del_this_pig_pen: "",
  confirm_to_disableuser: "",
  confirm_to_exit: "確定退出嗎",
  confirm_to_exit_the_upgrade: "",
  confirm_to_export_all_tenant_management_data_items: "",
  confirm_to_export_all_user_data_items: "",
  confirm_to_format: "確定格式化SD卡嗎",
  confirm_to_import_all_points: "",
  confirm_to_remove_this_robot: "",
  confirm_to_resetpassword: "",
  confirm_to_reset_password: "",
  confirm_to_restart: "確定重啓嗎",
  confirm_to_restore: "確定恢復出廠設置嗎",
  confirm_to_revoke_authorization_for_this_user_role: "",
  confirm_to_revoke_this_userrole: "",
  confirm_to_unbind_the_user: "",
  confrim_to_del_the_row: "",
  connect: "連接",
  connected: "已連接",
  connected_devices: "",
  connecting: "連接中",
  connecting_to_the_device: "連接設備中",
  connection_disconnected: "",
  connection_disconnected_pls_exit_and_try_again: "",
  connection_failed_incorrect_ip_port_or_device_network:
    "連接失敗，IP、埠錯誤或設備網路異常",
  connection_guide: "",
  connection_succeeded: "連接成功",
  connect_device: "連接設備",
  connect_device_manually: "手動連接設備",
  connect_failed: "連接失敗",
  connect_port_failed_device_is: "連接端口失敗,設備為",
  connect_via_device_access_point: "",
  consignee_phone_number: "",
  constant: "常量",
  consumer_hotline: "",
  contact: "",
  contact_cannot_be_empty: "",
  contact_customer_service: "",
  contact_information: "",
  contact_phone_number: "聯繫電話",
  content: "",
  content_page: "內容頁",
  continue_patrol: "繼續輪巡",
  continue_recording: "",
  continuous: "",
  continuous_rangefinding: "",
  contrast: "對比度",
  control_commands_cannot_be_enabled_during_video_recording: "",
  control_switch: "控製開關",
  conventional_resolution: "常規解析度",
  coop_name: "",
  coordinate_conversion_failed: "座標轉換失敗",
  coordinate_system: "坐標系",
  copper_coated_with_solder: "塗焊料的銅",
  copper_wire: "銅絲",
  copy: "複製",
  copy_to_clipboard_failed: "",
  copy_to_clipboard_succeed: "",
  core_ver: "機芯版本",
  coriolis_effect: "",
  corporate_account: "",
  corporate_jurisdical_person: "",
  corporate_name: "",
  corresponding_internal_network_port: "對應內網端口",
  corresponding_permission_is_required: "",
  cotton_textiles_all_colors: "棉紡織品(全顏色)",
  count: "",
  counterclockwise: "逆時針",
  county: "",
  coupon: "",
  coupon_simple: "",
  cpu_overload: "負載過高",
  cracked_eggs: "",
  cracked_egg_alarm: "",
  cracked_egg_analysis: "",
  create: "",
  create_account: "",
  create_config: "",
  create_new_group: "新建分組",
  create_new_house: "",
  create_new_page: "新建頁面",
  create_new_patrol: "新建輪巡",
  create_new_pen: "",
  create_new_role: "",
  create_new_task: "",
  create_new_template: "",
  create_new_user: "",
  create_new_view: "新建視圖",
  create_order: "",
  create_organization: "",
  create_success: "",
  create_time: "創建時間",
  creation_date: "",
  creation_failed: "",
  creation_successful: "",
  creator: "",
  critical: "嚴重",
  crossing_areas_are_not_allowed_to_be_drawn_pls_redraw:
    "不允許繪製交叉區域，請重新繪製！",
  cruise_ship: "遊輪",
  cumulative_sales: "",
  currently_in_continuous_rangefinding_mode: "",
  current_channel_has_no_downloadable_recordings: "當前通道無可下載錄影",
  current_computer_has_not_occupied_the_config_lock: "當前電腦未佔用配置鎖",
  current_coop: "",
  current_graphics_card_does_not_support_playing_h265_stream_pls_d:
    "當前顯卡不支持播放h265碼流，請下載操作文檔進行設置",
  current_height: "",
  current_location: "",
  current_network_is_lan_pls_switch: "",
  current_organization: "",
  current_patrol: "當前輪巡",
  current_patrol_is_previewing_cant_del: "正在輪巡，不能刪除",
  current_phone_number: "",
  current_point: "",
  current_recording_plan_and_linked_recording_stream_do_not_match_:
    "當前錄像計劃和聯動錄像碼流不一致，將錄製兩份文件，占用存儲空間資源翻倍, 是否繼續",
  current_software_ver_beta: "",
  current_view: "當前視圖",
  current_view_has_been_associated_with_patrol_and_cannot_be_deld:
    "當前視圖已被輪巡計畫關聯，暫不能删除",
  current_view_is_in_preview_mode_and_cannot_be_deld:
    "當前視圖正在預覽，不能刪除。",
  current_view_is_using_and_cannot_be_deld: "當前視圖正在使用，無法删除。",
  cur_device: "當前設備",
  customer_service: "",
  custom_spot: "自定義點",
  custom_time_period: "",
  cycle_setting_cannot_be_empty: "週期設置不能為空",
  d: "日",
  daily_new: "",
  daily_new_alarms: "",
  daily_weight_gain: "",
  data: "數據",
  database_table: "",
  data_already_exists: "資料已存在",
  data_append_failed: "資料添加失敗",
  data_cannot_be_empty: "",
  data_center: "數據中心",
  data_collection: "",
  data_deletion_failed: "資料刪除失敗",
  data_does_not_exist: "資料不存在",
  data_duplicate: "",
  data_error: "數據有誤",
  data_format_error_pls_contact_the_administrator: "",
  data_insertion_failed: "資料插入失敗",
  data_load_failed: "",
  data_monitoring: "",
  data_out_of_range: "數據越界",
  data_permis: "",
  data_permi_class_name: "",
  data_permi_class_name_cannot_be_empty: "",
  data_permi_field: "",
  data_permi_field_cannot_be_empty: "",
  data_permi_name: "",
  data_permi_name_cannot_be_empty: "",
  data_permi_range: "",
  data_permi_remarks: "",
  data_permi_type: "",
  data_permi_type_cannot_be_empty: "",
  data_retrieval_failed: "數據獲取失敗",
  data_source: "數據源",
  data_statistics: "",
  data_status: "",
  data_type: "數據類型",
  data_update_failed: "資料更新失敗",
  date: "",
  date_and_time: "日期時間",
  date_setting: "日期設置",
  day: "",
  days: "",
  day_age_days: "",
  day_age_must_be_0_or_a_positive_integer_and_no_longer_than_5_cha: "",
  day_ago: "",
  dde: "圖像增強",
  dead_chickens: "",
  dead_chicken_alarm: "",
  dead_chicken_analysis: "",
  dec: "十二月",
  decelerate: "減速",
  default_anti_keyword: "",
  default_charging_point: "",
  default_group: "默認分組",
  default_keyword: "",
  default_map: "",
  default_organiztion: "默認組織",
  default_password_is_12345678: "",
  default_path_cannot_be_removed: "默認路徑不能移除",
  default_role: "",
  default_settings: "默認設置",
  default_template: "默認範本",
  default_template_cannot_be_deld: "默認範本禁止刪除",
  default_template_name_cannot_be_modified: "預設範本禁止修改名稱",
  del: "刪除",
  deld_inspection_point_successfully: "",
  delete_original_file: "",
  deleting: "",
  deleting_linkage_strategy_failed: "刪除聯動策略失敗",
  deleting_linkage_strategy_succeeded: "刪除聯動策略成功",
  deleting_patrol_plan_failed: "刪除輪巡計畫失敗",
  deleting_patrol_plan_succeeded: "刪除輪巡計畫成功",
  deleting_qr_code_points_is_not_allowed: "",
  deleting_the_area_will_also_del_related_push_notifications_are_y:
    "將同時刪除區域相關的推送資訊，確定進行刪除操作?",
  del_account: "注销账号",
  del_all: "刪除所有",
  del_chicken_house: "",
  del_config: "",
  del_control: "刪除控件",
  del_failed: "删除失敗",
  del_from_cloud: "從雲平臺刪除",
  del_map: "",
  del_page: "刪除頁面",
  del_pig_house: "",
  del_pig_pen: "",
  del_point: "",
  del_robot: "",
  del_role: "",
  del_selected: "刪除選中",
  del_sel_file: "",
  del_success: "刪除成功",
  del_task: "",
  del_template: "",
  del_tenant: "",
  del_user: "",
  department: "",
  department_name: "",
  department_name_cannot_be_empty: "",
  department_status: "",
  deposit: "",
  depth_camera: "",
  depth_camera_abnormal: "",
  descending: "",
  descending_order_by_name: "按名稱降序",
  descending_order_by_time: "按時間降序",
  description_of_alarm_handling: "",
  desel_all: "",
  desel_user_authorization: "",
  desert: "沙漠",
  details: "詳情",
  detail_info: "詳細信息",
  detect: "發現",
  detection_distance: "",
  detection_item: "檢測項",
  detection_value: "檢測值",
  detector_temp: "探測器溫度",
  developing: "",
  device: "設備",
  device_alarm: "設備報警",
  device_alarm_source: "設備報警源",
  device_alarm_stopped_successfully: "設備停止報警成功",
  device_alarm_stop_failed: "設備停止報警失敗",
  device_alarm_subscription: "設備報警訂閱",
  device_alarm_template_number: "設備報警模板編號",
  device_alias_already_exists_in_this_organization: "當前組織已有該別名的設備",
  device_alias_required: "設備別名(必填)",
  device_already_added: "設備已添加",
  device_authority: "設備許可權",
  device_auth_failed: "設備認證失敗",
  device_battery_level: "設備電量",
  device_calibration: "設備校準",
  device_channel_number_error: "設備通道號錯誤",
  device_command_parameter_error: "設備指令參數錯誤",
  device_config: "設備配置",
  device_connected: "",
  device_connected_to_the_app: "",
  device_connection_failed: "",
  device_deletion_failed: "設備刪除失敗",
  device_disconnected: "",
  device_disconnected_pls_reconnect: "",
  device_discovery: "設備發現",
  device_does_not_exist: "設備不存在",
  device_driver: "",
  device_exception: "設備異常",
  device_file: "設備文件",
  device_find_error: "設備查詢失敗",
  device_id: "設備編碼",
  device_import_failed_information_table: "設備導入失敗信息表",
  device_import_information_table: "設備導入信息表",
  device_import_information_table_do_not_include_empty_lines_or_sp:
    "設備導入資訊表（請勿空行、空格）",
  device_info: "設備信息",
  device_information_management: "設備資訊管理",
  device_ip: "設備IP",
  device_ip_or_port_number_error: "設備IP或埠號錯誤",
  device_ip_or_port_number_is_incorrect: "設備IP或端口號錯誤",
  device_is_not_added_to_cloud: "設備未添加到雲平臺",
  device_is_offline: "裝置已離線",
  device_is_offline_no_stream_information: "設備不線上無流資訊",
  device_language_sel: "設備語言選擇",
  device_layer: "設備圖層",
  device_linkage: "設備聯動",
  device_link_guide: "設備鏈接指南",
  device_list: "設備列表",
  device_location: "設備位置",
  device_login: "登錄設備",
  device_malfunction: "",
  device_mgt: "設備管理",
  device_model: "設備型號",
  device_monitoring: "",
  device_name: "設備名稱",
  device_name_cannot_be_empty: "設備名稱不能為空",
  device_name_exists: "設備名稱重複",
  device_network_connection_exception: "設備網路連接異常",
  device_network_issue: "设备网络异常",
  device_not_found_in_the_platform: "平臺內沒有添加該設備",
  device_not_retrieved: "未獲取到設備",
  device_offline: "設備離線",
  device_ops: "設備運維",
  device_or_channel_does_not_exist: "設備或通道不存在",
  device_or_channel_query_failed: "設備或通道查詢失敗",
  device_pan_tilt_control_stop_exception_pls_check_the_device:
    "設備雲台控制停止異常，請檢查設備",
  device_password: "設備密碼",
  device_playback_streaming_failed: "設備播放推流失敗",
  device_preset_control_exception_pls_check_the_device:
    "設備預置位元控制異常，請檢查設備",
  device_preset_deletion_exception_pls_check_the_device:
    "設備預置位元刪除異常，請檢查設備",
  device_ptz_control_start_failed_pls_check_the_device:
    "設備雲台控制啟動異常，請檢查設備",
  device_reboot: "",
  device_rebooted_successfully: "",
  device_rebooting_pls_wait: "",
  device_registration_save_error: "設備註冊保存出錯",
  device_registration_save_error_pls_check_if_the_device_and_chann:
    "設備註冊保存出錯，請檢查設備及通道資訊是否正確",
  device_sdk_invocation_error: "設備SDK調用錯誤",
  device_searching: "",
  device_service_read_failed_pls_disconnect_and_reconnect: "",
  device_status: "設備狀態",
  device_status_left: "",
  device_status_right: "",
  device_type: "",
  device_username: "設備用戶名",
  device_ver: "設備版本",
  device_view: "",
  device_wifi_has_been_modified_manual_device_restart_required_for: "",
  diagonal_flip: "對角翻轉",
  dialog_box: "對話框",
  dictionary_label: "",
  dictionary_name: "",
  digital_camera: "數碼相機",
  digital_camera_exception: "",
  digital_camera_information: "",
  dimension: "",
  diopter_adjustment_range: "",
  directory: "目錄",
  directory_name: "目錄名稱",
  direct_switching: "直接切換",
  dirty_chicken_cage_alarm: "",
  disable: "停用",
  disabled_successfully: "",
  disable_audio: "關閉聲音",
  disable_img_super_resolution: "關閉圖片超分",
  disable_img_super_resolution_and_reboot: "是否關閉圖片超分，重啟生效",
  disable_ipc_popup: "關閉IPC彈窗",
  disable_panor_popup: "關閉全景彈窗",
  disable_popup: "禁用彈窗",
  disable_successful: "",
  disable_super_resolution_and_reboot: "是否關閉超分，重啟生效",
  disagree: "不同意",
  disaster: "災難",
  disconnect: "斷開",
  disconnected: "",
  discount_amount: "",
  disk_offline: "硬盤離線",
  display: "顯示",
  display_brightness: "顯示屏亮度",
  display_order: "",
  display_order_cannot_be_empty: "",
  display_resolution: "",
  display_settings: "",
  display_time: "時間顯示",
  disposal_advice: "",
  disposal_advice_cannot_be_empty: "",
  disposal_advice_should_not_exceed_100_characters: "",
  disposal_status: "",
  distance: "距離",
  distance_cost: "",
  distance_from_origin: "",
  distance_from_origin_cannot_be_empty: "",
  distance_from_origin_meters: "",
  distance_from_origin_should_be_a_non_negative_number: "",
  distance_is_out_of_range: "距離超出範圍",
  distance_is_required: "距離不能為空",
  distance_price: "",
  distance_unit: "距離單位",
  distance_value: "",
  diving_support_vessel: "潛水作業船",
  dmc: "",
  does_not_support_low_energy_bluetooth: "不支持低功耗藍牙",
  dont_have_an_account: "還沒有帳號",
  dont_have_an_account_yet: "",
  down: "下",
  download: "下載",
  downloaded: "已下載",
  downloading: "下載中",
  download_center: "下載中心",
  download_completed: "",
  download_completed_pls_check_in_phone_gallery: "",
  download_exception_pls_try_again_later: "",
  download_failed: "下載失敗",
  download_failed_items: "下載失敗條目",
  download_finish: "下載完成",
  download_firmware: "下载固件",
  download_logs: "",
  download_management: "",
  download_path: "下載路徑",
  download_start: "下載開始",
  download_success: "下載成功",
  download_success_install_now: "",
  download_template: "下載範本",
  download_the_upgrade_package_to_your_phone: "下載升級包至手機",
  do_not_encode_manually: "請勿自行編碼",
  do_not_power_off_during_the_upgrade: "設備升級中，請勿斷電",
  do_not_remind_again: "不再提醒",
  do_you_want_to_del: "確定移除任務嗎？",
  do_you_want_to_logout: "確定註銷嗎？",
  do_you_want_to_overwrite_this_file: "是否覆蓋該檔",
  do_you_want_to_upgrade_to: "",
  drag_model: "",
  draw_temp_ellipse: "繪製測溫橢圓形",
  dredging_or_subsea_ope_ship: "挖掘或水下作業船",
  drone: "無人機",
  dual_spectrum_fusion_registration: "雙光融合配準",
  dual_spectrum_registration: "雙光配准設置",
  duplicated_group_name_pls_rename: "分組名稱與已有的重複，請重新命名",
  duplicated_patrol_name_pls_rename: "輪巡名稱與已有的重複，請重新命名",
  duplicated_view_name_pls_rename: "視圖名稱與已有的重複，請重新命名",
  duplicate_area: "區域重複",
  duplicate_domain_value: "域值重複",
  duplicate_field_value: "字段值重復",
  duplicate_name: "名稱重複",
  duplicate_resource_name_as_in_the_0th_row: "和第{0}行資源名稱重複",
  duplicate_resource_name_as_in_the_2nd_row: "和第2行資源名稱重複",
  duplicate_task_name: "",
  duplicate_template_name: "",
  duplication_file_name: "檔名重複",
  duration: "時長",
  duration_for_ai_recognition_frame_extraction: "AI識別取幀時長",
  during_the_acquisition_of_device_io_channel_information_if_there:
    "設備IO通道資訊獲取中，如超過5分鐘無數據，請與設備廠商或技術支援聯繫。",
  dwell_time: "停留時間",
  d_view: "3D視圖",
  each_page: "每頁",
  east_northeast: "東偏北",
  east_southeast: "東偏南",
  edit: "編輯",
  edit_address: "",
  edit_associated_group: "編輯關聯組",
  edit_inspection_actions: "",
  edit_integrated_judgment_rules: "編輯綜合研判規則",
  edit_manufacturer: "",
  edit_patrol: "編輯輪巡",
  edit_report_conclusions: "",
  edit_shielded_area: "編輯屏蔽區域",
  egg_laying_chicken_customer_administrator: "",
  egg_production: "",
  egg_production_analysis: "",
  egg_production_count: "",
  egg_production_rate: "",
  egg_production_rate_statistics: "",
  egg_production_statistics: "",
  electric: "電力",
  electric_ceramies: "電瓷",
  elevating_inspection: "",
  email: "",
  email_address_cannot_be_empty: "",
  email_cannot_be_empty: "",
  email_server_account: "郵件服務器賬戶",
  email_server_ip: "郵件服務器IP",
  email_server_password: "郵件服務器密碼",
  email_server_port: "郵件服務器端口",
  email_server_settings: "郵件服務器設置",
  emap: "電子地圖",
  emap_module: "",
  emergency_event: "",
  emergency_event_videos_are_only_stored_on_the_deviceif_you_want_: "",
  emergency_stop: "",
  emergency_stop_status: "",
  emergency_stop_switch: "",
  emissivity: "發射率",
  emissivity_is_out_of_range: "發射率超出範圍",
  emissivity_is_required: "發射率不能為空",
  empty: "這裏空空如也",
  empty_task_file: "任務文件爲空",
  empty_username_or_pwd: "用戶名或密碼不能為空",
  enable: "生效",
  enabled_successfully: "",
  enable_audio: "打開聲音",
  enable_avg_temp: "顯示平均溫",
  enable_device_wifi: "",
  enable_edge_alarm_bar: "開啟側邊報警欄",
  enable_frame: "顯示整幀溫度",
  enable_gpu: "啟用GPU",
  enable_img_super_resolution: "開啟圖片超分",
  enable_img_super_resolution_and_reboot: "是否開啟圖片超分，重啟生效",
  enable_ipc_popup: "開啟IPC彈窗",
  enable_level: "啟用級別",
  enable_max_temp: "顯示最高溫",
  enable_min_temp: "顯示最低溫",
  enable_opengles: "啟用OpenGLES",
  enable_panor_popup: "開啟全景彈窗",
  enable_popup: "啟用彈窗",
  enable_pwd: "啟用密碼",
  enable_status: "啟用狀態",
  enable_successful: "",
  enable_super_resolution_and_reboot: "是否開啟超分，重啟生效",
  enable_temp_rise_alarm: "啟用溫升報警",
  enable_the_device_hotspot_with_which_pair_the_phone_wlan:
    "打開設備熱點，將手機無線網路與設備熱點配對",
  enable_the_phone_hotspot_with_which_pair_the_device_wlan:
    "打開手機熱點，將設備無線網路與手機熱點配對",
  enable_zeroing_weather: "",
  encapsulation: "",
  encoder: "編碼設備",
  encryption_type: "",
  end: "結束",
  ended: "",
  end_action: "",
  end_date: "",
  end_date_can_not_be_earlier_than_current_data: "結束日期不能早於當前日期",
  end_date_required: "結束日期不能為空",
  end_multiplier: "",
  end_page: "尾頁",
  end_time: "結束時間",
  end_time_required: "結束時間不能為空",
  end_tour: "結束巡航",
  end_zoom_speed: "",
  end_zoom_speed_should_be_lower_than_start_zoom_speed: "",
  enforcement_vessel: "執法船",
  english: "英语",
  enlarge: "電子變倍",
  ensure_the_mobile_hotspot_settings_match_the_device: "",
  enter_alias: "請輸入別名",
  enter_channel_alias_for_filtering: "輸入通道別名篩選",
  enter_content_filter: "請輸入內容篩選",
  enter_latitude_longitude_eg_27658_120255:
    "輸入緯度,經度(例如:27.658,120.255)",
  enter_password_to_unlock: "輸入密碼以解鎖",
  enter_the_wifi_settings_of_the_smartphone: "",
  entries_page: "",
  entry_date: "",
  entry_time: "",
  env_monitoring: "",
  env_param: "環境參數",
  "env_temp_alarm_threshold_℃": "",
  env_temp_monitoring: "",
  eos_base_map_management: "周掃底圖管理",
  eos_device: "周掃設備",
  eos_name: "周掃名稱",
  epidemic_prevention_and_control: "疫情防控",
  epoxy_glass_substrate: "環氧玻璃板",
  equal_to: "等於",
  equipment_channel: "設備通道",
  error: "",
  error_device: "設備有誤",
  error_in_the_0_row: "第{0}行錯誤",
  error_in_the_1st_row: "第1行錯誤",
  error_in_video_file: "",
  error_prompt: "錯誤提示",
  estimated_execution_time: "",
  estimated_weight_of_pigs: "",
  evaluate: "",
  event: "事件",
  event_alarm_config: "業務報警配置",
  event_alarm_data: "業務報警數據",
  event_alarm_linkage: "業務報警聯動",
  event_alarm_settings: "業務報警設置",
  event_alarm_statistics_sending_settings: "業務報警統計發送設置",
  event_alarm_subscription: "業務報警訂閱",
  event_alarm_template_number: "業務報警模板編號",
  event_alarm_voice_settings: "業務報警語音設置",
  event_does_not_exist: "事件不存在",
  event_handle: "事件處理",
  event_level: "事件級別",
  event_linkage: "事件聯動",
  event_linkage_is_already_added_for_the_device_source:
    "設備源已經添加事件聯動",
  event_record_does_not_exist: "事件記錄不存在",
  event_type: "事件類型",
  every_day: "",
  every_hour: "",
  every_six_hours: "",
  every_three_hours: "",
  every_twelve_hours: "",
  every_twenty_four_hours: "",
  every_two_hours: "",
  example_set_from_1800_to_600_meaning_enable_from_600_pm_to_600_a: "",
  excavator: "挖掘機",
  exceptional: "是否異常",
  execute: "",
  execute_immediately: "",
  execution_frequency: "",
  execution_method: "",
  execution_strategy: "",
  exercise_caution: "",
  exit: "退出登錄",
  exited: "已退出",
  exiting_pls_wait: "正在關閉",
  exiting_will_disable_the_alarm_linkage: "退出後會關閉報警聯動",
  exit_successful: "退出成功",
  exit_system: "",
  expiration_time: "過期時間",
  expired: "已失效",
  export: "導出",
  exporting: "導出中",
  export_all_reports: "導出全部報告",
  export_all_rules: "導出全部規則",
  export_as_fvms_player_format: "導出為FVMS Player格式",
  export_as_fvms_specific_format_only_playable_with_fvms_player:
    "導出FVMS特定格式，僅可使用FVMS Player播放器播放。",
  export_as_media_format: "導出為媒體格式",
  export_as_vis_3000_player_format: "導出為VIS-3000 Player格式",
  export_as_vis_3000_specific_format_only_playable_with_vis_3000_p:
    "導出VIS-3000特定格式，僅可使用VIS-3000 Player播放器播放。",
  export_curve: "導出曲線",
  export_data: "數據匯出",
  export_failed: "導出失敗",
  export_information: "匯出資訊",
  export_media_format_files_such_as_mkv_mp4_etc_which_can_be_playe:
    "導出Mkv、MP4等媒體格式檔，可使用本地播放器播放。",
  export_report: "導出報告",
  export_report_successfully: "導出報表成功",
  export_success: "導出成功",
  export_table: "導出報表",
  export_temp: "導出溫度數據",
  export_template: "導出範本",
  export_time: "導出時間",
  export_user_files: "匯出用戶檔",
  export_video: "導出視頻",
  export_video_failed: "導出視頻失敗",
  export_video_success: "導出視頻成功",
  external_network: "外網",
  external_network_address_settings: "外網映射位址設置",
  ext_connect_dev_online_ratio: "外聯設備在綫比例",
  e_mail: "",
  face_capture: "人臉抓拍",
  face_img_path: "人臉圖片路徑",
  factory_reset: "恢復出廠",
  factory_reset_failed: "恢復出廠設置失敗",
  factory_reset_succeeded: "恢復出廠設定成功",
  fahrenheit: "華氏度",
  failed: "失敗",
  failed_to_add_belonging_map_has_been_deld: "",
  failed_to_add_device_pls_confirm_the_connection_is_normal:
    "添加設備失敗，請確認網路是否正常",
  failed_to_add_inf_temp_measurement_area: "添加紅外測溫區域失敗",
  failed_to_add_preset: "添加預置位失敗",
  failed_to_add_role_name_already_exists: "",
  failed_to_add_role_permis_already_exist: "",
  failed_to_add_template: "添加模板失敗",
  failed_to_be_deleted_pls_plug_and_unplug_sd_card:
    "部分檔案删除失敗,請重新插拔SD卡",
  failed_to_create_facial_recognition_database: "人臉庫創建失敗",
  failed_to_create_new_inspection_point_duplicate_point_name: "",
  failed_to_create_upgrade_file: "",
  failed_to_del_data_in_cloud: "從雲平臺刪除失敗",
  failed_to_del_inf_temp_measurement_area: "刪除紅外測溫區域失敗",
  failed_to_del_inspection_point: "",
  failed_to_del_map_associated_with_inspection_template: "",
  failed_to_del_map_point_associated_with_inspection_task: "",
  failed_to_del_map_point_associated_with_inspection_template: "",
  failed_to_del_preset: "刪除預置位失敗",
  failed_to_del_template: "刪除模板失敗",
  failed_to_exchange_templates: "交換模板失敗。",
  failed_to_export_alarm_records: "匯出報警記錄失敗",
  failed_to_get_canvas: "獲取畫布失敗",
  failed_to_get_certificate_information: "獲取證書資訊失敗",
  failed_to_get_inf_temp_measurement_area: "獲取紅外測溫區域失敗",
  failed_to_get_points_network_connection_abnormal: "",
  failed_to_get_preset_patrol_plan: "獲取預置位巡航計畫失敗",
  failed_to_get_scan_patrol_plan: "獲取掃描巡航計畫失敗",
  failed_to_get_template_list: "獲取模板列表失敗",
  failed_to_get_the_first_alarm_event: "獲取首個報警事件失敗",
  failed_to_get_the_upgrade_status_pls_check_the_device_connection:
    "獲取升級狀態失敗，請確認設備連接是否正常",
  failed_to_get_video_information_pls_retry: "獲取視頻資訊失敗，請重試",
  failed_to_invoke_preset: "調用預置位失敗",
  failed_to_invoke_wiper: "調用雨刷失敗",
  failed_to_modify_email_account_already_exists: "",
  failed_to_modify_mute_notifications: "",
  failed_to_modify_phone_number_already_exists: "",
  failed_to_modify_push_switch: "",
  failed_to_modify_role_name_already_exists: "",
  failed_to_modify_role_permis_already_exist: "",
  failed_to_modify_template: "修改模板失敗",
  failed_to_obtain_location: "未能獲取地點",
  failed_to_obtain_the_certificate_pls_contact_the_administrator:
    "獲取證書失敗，請聯系管理員",
  failed_to_obtain_the_machine_code_pls_contact_the_administrator:
    "獲取機器碼失敗，請聯系管理員",
  failed_to_play_audio: "播放音頻失敗",
  failed_to_play_pls_refresh_and_reload: "播放失敗，請刷新重新加載",
  failed_to_query_recording_plan: "查詢錄影計畫失敗",
  failed_to_rename: "重命名失敗",
  failed_to_retrieve_address: "獲取地址失敗",
  failed_to_retrieve_channel_information: "",
  failed_to_retrieve_location_information: "",
  failed_to_retrieve_navigation_device_information: "",
  failed_to_retrieve_recording_plan: "獲取錄影計畫失敗",
  failed_to_retrieve_upgrade_information: "獲取升級資訊失敗",
  failed_to_retrieve_upgrade_status_pls_check_if_the_device_is_con:
    "獲取升級狀態失敗，請檢查設備是否連接",
  failed_to_save_blind_element_settings: "",
  failed_to_save_img: "",
  failed_to_set_auto_time_sync_pls_contact_administrator: "",
  failed_to_set_manual_time_sync_the_reason_for_failure_is_an_inva: "",
  failed_to_set_parameters_for_inf_temp_measurement_area:
    "設置紅外測溫區域參數失敗",
  failed_to_set_template: "設置範本失敗",
  failed_to_start_analysis: "開始分析失敗",
  failed_to_stop_rangefinding: "",
  failed_to_update_bullet_library: "",
  failed_to_update_firearm_library: "",
  failed_to_update_fire_severity: "火情等級更新失敗",
  failed_to_update_inspection_point: "",
  failed_to_update_manufacturer_library: "",
  failed_to_update_sight_library: "",
  fail_to_send_pls_update_again: "",
  false_alarm: "",
  false_alarm_shielding: "誤報遮罩",
  far_focus: "遠焦",
  fast: "快放",
  fast_forward: "快進",
  fast_play_speed: "快速回放速度",
  fattening_pig_customer_administrator: "",
  fault: "",
  favorite: "",
  favorites: "收藏",
  feather: "",
  feathers: "",
  feb: "二月",
  febrile_pigs: "",
  feedback: "意見回饋",
  feeder: "",
  feeder_analysis: "",
  fee_mode: "",
  female: "",
  file_already_exists: "文件已存在",
  file_downloading_pls_wait: "",
  file_format: "檔格式",
  file_format_error_pls_upload_img_types_such_as_jpg_or_png: "",
  file_format_validation_failed: "檔格式校驗失敗",
  file_library: "檔庫",
  file_name: "文件名稱",
  file_name_is_required: "檔案名不能為空",
  file_name_should_not_contain_special: '檔名不支持*<>|\\`":.?/',
  file_not_found: "",
  file_not_found_pls_confirm_device:
    "未搜索到文件，请确定已连接设备并且设备sd卡正常插入",
  file_path: "檔路徑",
  file_saving_period: "檔保存天數",
  file_saving_period_can_not_be_empty: "文件保存天數不能為空",
  file_size: "文件大小",
  file_type: "檔案類型",
  file_upload_failed_pls_check_ftp_server_config: "",
  file_upload_size_cannot_exceed_200mb: "上傳檔大小不能超過200MB!",
  file_verification_failed_pls_replace_the_upgrade_file_or_re_impo: "",
  filter: "濾波",
  filter_criteria: "",
  filter_false_alarm: "誤報過濾",
  filter_time: "過濾時間",
  find: "查找",
  fine_tuning: "微調",
  fingerprint: "指紋",
  finished: "",
  fire: "火災",
  firearm_information: "",
  firearm_list: "",
  firearm_name_already_exists_pls_edit_again: "",
  fire_alarmfa: "火情告警",
  fire_area: "火情面積",
  fire_behavior_change_thermal: "火勢變化(熱成像)",
  fire_detection: "火點檢測",
  fire_extinguished: "火已撲滅",
  fire_info: "火點信息",
  fire_level_cannot_be_empty: "火情等級不能為空",
  fire_location: "火點位置",
  fire_point_altitude: "火點海拔",
  fire_point_coordinates: "火點座標",
  fire_recognition_algorithm_visible: "火識別演算法(可見光)",
  fire_setting: "火災設置",
  fire_severity: "火情等級",
  fire_status: "火情狀態",
  fire_type: "火災類型",
  firmware: "固件",
  firmware_transfer_requires_phone_to_be_connected_to_the_devices_:
    "傳輸固件需要手機連接到設備的WiFi網絡",
  firmware_update: "",
  firmware_upgrade: "固件升級",
  firmware_version: "固件版本",
  firmware_ver_is_low_pls_upgrade_to_the_latest_ver:
    "固件版本低，請升級至最新版本",
  first_execution_time: "",
  first_login_pls_change_your_password: "",
  fishing_boat: "漁船",
  five_minutes: "5分鐘",
  flip: "",
  flower_blue: "花青",
  focal_length: "",
  focus: "聚焦",
  fold: "折疊",
  folder: "檔夾",
  font: "字體",
  font_color: "字體顏色",
  font_setting: "字體設置",
  font_size: "字體大小",
  forest_fire: "森林火災",
  forest_fire_alarm_merge_rule_settings: "森林防火報警合併規則設置",
  forest_fire_false_alarm_filtering_rule_settings: "森林防火誤報過濾規則設置",
  forest_fire_integrated_judgment_rule_settings: "森林防火綜合研判規則設置",
  forest_fire_intelligent_judgment_rule_settings: "森林防火智能研判規則設置",
  forest_fire_intelligent_judgment_switch_settings: "森林防火智能研判開關設置",
  forest_fire_overview: "林火一張圖",
  forest_fire_prevention: "森林防火",
  forest_green: "",
  forgot_pwd: "",
  format_sd_card: "格式化SD卡",
  format_success: "格式化成功",
  forsale: "",
  for_rent: "",
  for_the_alarm_rule_of_high_temp_greater_than_the_alarm_level_tem:
    "報警規則為高溫大於時，報警等級溫度應逐級增高",
  four_windows: "四個視窗",
  fov: "",
  fpa_temp: "FPA溫度",
  fps: "幀頻",
  fpv: "FPV",
  frames_with_ai_recognition_confidence_equal_to_or_less_than_this:
    "單幀AI識別可信值小於等於該閾值將被認為：圖像幀指定位置非識別對象",
  frame_range: "幀範圍",
  frame_rate: "幀率",
  frame_rate_setting: "幀率設置",
  frame_temp: "整幀溫度",
  free_shipping: "",
  french: "法語",
  frequency: "",
  friday: "週五",
  front_of_the_car: "",
  front_radar: "",
  front_radar_exception: "",
  front_radar_information: "",
  ft: "英尺",
  ftp_connection: "",
  ftp_service_error_pls_quit_and_login_again: "",
  ftp_settings: "",
  full_frame: "整幀  ",
  full_region_name: "區域全名",
  full_region_name_is_required: "區域全名不能為空",
  full_screen: "全屏",
  function: "功能",
  function_authority: "功能許可權",
  function_name: "功能名稱",
  fuse: "融合",
  fuse_mode: "融合模式",
  fusion_ratio: "融合比例",
  gain_mode: "增益模式",
  gallery: "素材庫",
  galvanized_bright_iron_plate: "鍍鋅亮鐵板",
  gas_concentration: "氣體濃度",
  gas_detection_mode: "氣體檢測檔位",
  gas_enhancement: "氣體增强",
  gas_parameter_settings: "氣體參數設置",
  gas_sensor: "",
  gas_sensor_information: "",
  gas_sensor_malfunction: "",
  gateway: "網關",
  gear_shifting_in_progress_pls_try_again_later: "檔位切換中，請稍後再試",
  gender: "",
  general: "通用",
  general_prompt: "常規提示",
  geographical_location_info_not_obtained_yet: "暫未獲取地理位置信息",
  german: "德語",
  get_array_size_failed: "獲取陣列規模失敗",
  get_atmospheric_temp_failed: "獲取環境溫度失敗",
  get_brightness_failed: "獲取亮度失敗",
  get_contrast_failed: "獲取對比度失敗",
  get_dde_enabled_failed: "獲取圖像增強使能失敗",
  get_dde_failed: "獲取圖像增強失敗",
  get_detector_temp_failed: "獲取探測器溫度失敗",
  get_distance_failed: "獲取距離失敗",
  get_emissisivity_failed: "獲取發射率失敗",
  get_encryption_type_failed: "",
  get_filter_enabled_failed: "獲取濾波使能失敗",
  get_from_compass: "",
  get_from_gps: "",
  get_gain_mode_failed: "獲取增益模式失敗",
  get_image_flip_failed: "獲取圖像翻轉失敗",
  get_img_again: "重新獲取圖片",
  get_measurement_range_failed: "獲取測溫範圍失敗",
  get_osd_failed: "獲取網板疊加狀態失敗",
  get_palette_failed: "獲取偽彩失敗",
  get_parameters: "獲取參數",
  get_product_id_failed: "獲取產品序列號失敗",
  get_product_number_failed: "獲取產品編號失敗",
  get_product_temp_failed: "獲取產品溫度失敗",
  get_reflected_temp_failed: "獲取反射溫度失敗",
  get_the_price_after_login_auth: "",
  get_transmittance_failed: "獲取透過率失敗",
  get_weather: "",
  glass_surface: "玻璃(面)",
  global: "",
  going: "",
  gold_plated_copper: "鍍金銅片",
  got_it: "",
  go_here: "去這裡",
  go_to: "轉到",
  go_to1: "",
  go_to_enable: "去開啟",
  go_to_page_: "",
  go_to_settings: "去設置",
  go_to_wifi_settings_on_the_phone: "進入手機wifi設置",
  gps_malfunction: "",
  gps_status: "",
  gps_status_display: "",
  graphics_card_does_not_suppot: "顯卡不支持",
  graphic_details: "",
  greater_than: "大於",
  green: "綠",
  greenhot: "綠熱",
  greenred: "青紅",
  green_shades: "漸變綠",
  group: "分組",
  group_buy: "",
  group_shop: "",
  guidance_throughout_product_usage_upgraded_experience_more_fan_b:
    "全程指導產品使用，優享升級體驗，更多粉絲福利…",
  h: "時",
  h265_playback_instructions: "h265播放說明",
  handheld_device: "手持設備",
  handheld_mode: "手持模式",
  handheld_online_mode: "手持+線上模式",
  handled_successfully: "處置成功",
  handler: "",
  handle_and_push: "處置並推送",
  handling: "",
  handling_result: "",
  header_title: "頁眉標題",
  header_title_setting: "頁眉標題設置",
  heads: "",
  health: "健康",
  healthy_illumination_threshold: "",
  height_rangefinding: "",
  hello_0_detection_1_triggered_a_fire_alarm_at_2_with_an_alarm_le:
    "您好，{0}檢測{1}在{2}發生火情報警，告警等級為{3}，火點座標為{4}",
  help: "幫助",
  hide: "隱藏",
  hierarchical_alarm_information_shielding: "分級報警信息屏蔽",
  high: "高",
  highlight: "",
  highlight_type: "凸顯類型",
  high_frequency: "",
  high_gain: "高增益",
  high_highlight: "高溫凸顯",
  high_speed_vessel: "高速船",
  high_temp: "高溫閾值",
  high_temperature: "高溫",
  high_temperature_low_temperature: "高溫溫度值需大於低溫溫度值",
  high_temp_equal_to: "高溫等於",
  high_temp_mode: "高溫檔",
  high_temp_value: "高溫值",
  hikvision: "海康",
  histogram: "直方圖",
  historical_data: "歷史數據",
  ho: "高溫設置",
  home_page: "首頁",
  horizontal: "",
  horizontal_angle: "",
  horizontal_angle_offset: "水平角偏移量",
  horizontal_click_value: "",
  horizontal_mounting_angle: "安裝水平角",
  horizontal_right_left: "",
  hot_iron: "熱鐵",
  hot_sale: "",
  hot_spot: "熱點追踪",
  hours: "小時",
  hour_ago: "",
  house_name_must_be_numbers_or_chinese_characters_and_no_longer_t: "",
  hovercraft: "地效應船",
  how_to_connect_the_device: "",
  human: "人",
  humidity: "濕度",
  humidity_cloud_map: "",
  humidity_rh: "",
  humidity_sensor_status: "",
  hungarian: "匈牙利語",
  hydrogen_sulfide: "硫化氫",
  ice: "冰",
  icefire: "冰火",
  icon: "圖示",
  icon_size_limit_5mb: "上傳圖示大小不能超過5M!",
  identical: "",
  identification_distance: "",
  idle: "",
  idle_action: "",
  idle_action_trigger_time: "",
  if_either_is_set_to_blank_no_statistical_notifications_will_be_s:
    "二者任意設置為空時，不會發送統計通知",
  if_the_above_steps_are_correct_you_can_reset_the_wifi_and_reconn: "",
  if_the_black_body_temp_is_30_the_set_temp_is_300:
    "如黑體溫度30度，需設置溫度為300度",
  if_the_device_is_not_connected_for_a_long_time_you_can_try_the_f: "",
  if_the_ratio_of_the_total_number_of_frames_recognized_to_the_num:
    "識別到指定對象單幀總數/取幀數的比例小於等於該閾值將被認為：過程中無識別對象",
  if_the_robot_is_currently_performing_a_patrol_task_one_key_retur: "",
  if_you_confirm_the_ope_the_download_will_be_terminated_after_the: "",
  if_you_want_to_add_new_alarms_and_alarm_sources_for_already_set_:
    "已設置人員如果要添加新報警和報警源，請在修改頁面設置",
  if_you_want_to_add_new_alarms_and_linkage_actions_for_already_se:
    "已設置報警源如果要添加新報警和聯動動作，請在修改頁面設置",
  ignore_aspect_ratio: "忽略縱橫比",
  illegal_region_name: "非法區域名稱",
  illegal_role_name: "",
  illuminator: "補光燈",
  image: "圖片",
  image_adjust: "圖像調節",
  image_analysis: "圖片分析",
  image_capture: "拍照",
  image_flip: "圖像翻轉",
  image_fusion: "",
  image_mode: "圖片模式",
  imgs_for_ai_recognition_will_be_extracted_within_the_specified_d:
    "用於AI識別的圖像將從觸發時刻附近的指定時長內提取",
  img_brightness: "",
  img_captured_successfully_pls_check_in_the_phone_gallery: "",
  img_capture_failed: "",
  img_capture_succeeded: "",
  img_contrast: "",
  img_loading_failed: "",
  img_offset: "圖像偏移量",
  img_preview: "圖片預覽",
  img_saved_successfully: "圖片保存成功",
  img_save_failed: "圖片保存失敗",
  img_stabilization: "穩像",
  img_upload_failed_pls_contact_the_administrator: "",
  img_viewing: "",
  imix: "細節增強",
  imix_mode: "細節增强模式",
  imo_code: "國際海事組織編碼",
  impor: "導入",
  importing: "導入中",
  importing_closing_will_stop_the_import_process:
    "導入中，關閉將會停止導入信息",
  import_all_rules: "導入全部規則",
  import_authorization_certificate: "導入授權證書",
  import_by_cage: "",
  import_by_column: "",
  import_by_map: "",
  import_failed: "導入失敗",
  import_img: "導入圖片",
  import_logo: "導入Logo",
  import_method: "",
  import_points: "",
  import_status: "導入狀態",
  import_success: "導入成功",
  import_template: "導入範本",
  imu_anomaly: "",
  imu_information: "",
  incomplete_device_information_retrieval: "獲取設備資訊不完整",
  incomplete_request_parameters_pls_check_if_devid_starttime_endti:
    "請求參數不完整，請檢查是否設置了devIdd, startTime, endTime",
  incorrect_cage_columns_format: "",
  incorrect_cage_layers_format: "",
  incorrect_cage_rows_format: "",
  incorrect_email_format: "郵箱格式不正確",
  incorrect_import_img_format: "導入圖片格式不正確",
  incorrect_input: "",
  incorrect_latitude_format: "緯度格式不對",
  incorrect_longitude_format: "經度格式不對",
  incorrect_menu_route_format_format_should_be_sys_menu:
    "菜單路由格式錯誤，格式為：/sys/menu",
  incorrect_number_of_common_channels_or_abnormal_channel_status_p:
    "普通通道數量不正確或者通道狀態異常，請檢查設備配置",
  incorrect_number_of_eos_channels_or_abnormal_channel_status_pls_:
    "周掃通道數量不正確或者通道狀態異常，請檢查設備配置",
  incorrect_original_pwd: "原密碼錯誤",
  incorrect_or_expired_verification_code: "驗證碼錯誤或已過期",
  incorrect_password_entered: "輸入的密碼有誤",
  incorrect_phone_number_format: "聯繫電話格式輸入錯誤",
  incorrect_phone_number_or_password: "手機號或密碼錯誤",
  incorrect_resource_name_format: "資源名稱格式不對",
  incorrect_user_type: "",
  incorrect_verification_code: "驗證碼錯誤",
  independent_report: "獨立報告",
  index_mode: "索引模式",
  individual_analysis_for_atp_device: "ATP設備只能單獨分析",
  info: "信息",
  infrared_flashlight: "",
  inf_camera_abnormal: "",
  inf_enhancement: "",
  inf_full_frame_temp_data: "",
  inf_light: "",
  inf_malfunction: "",
  inf_panoramic_eos_360: "周掃",
  inf_panoramic_eos_360_nvr: "周掃NVR",
  inf_polarity: "",
  inf_pseudo_color: "",
  inf_pseudo_color_enabled_successfully_effective_in_inf_fusion_im: "",
  inf_scenarios: "",
  inf_snapshot: "",
  inf_temp_measurement_area_exceeds_limit: "紅外測溫區域超出限制",
  inf_visible_light_split_screen: "",
  initialization_point: "",
  initiate_closure: "",
  input_information_is_illegal_pls_correct_it: "輸入資訊非法,請糾正!",
  input_the_new_password_again: "",
  insert_sd_card_or_restart_the_device: "插入sd卡或重啓設備",
  inspected: "",
  inspected_points: "",
  inspection_actions: "",
  inspection_anomaly: "",
  inspection_completed: "",
  inspection_count: "",
  inspection_failed: "",
  inspection_in_progress: "",
  inspection_method: "",
  inspection_point: "",
  inspection_point_order: "",
  inspection_point_result: "",
  inspection_progress: "",
  inspection_results: "",
  inspection_result_report: "",
  inspection_result_storage_time: "",
  inspection_robot: "",
  inspection_status: "",
  inspection_tasks: "",
  inspection_task_abnormality_points_completed_points_remaining_un: "",
  inspection_task_exception_completed_point_count: "",
  inspection_task_issued_but_the_robot_did_not_respond: "",
  inspection_task_is_being_started_pls_wait: "巡檢任務開啓中,請稍候",
  inspection_task_start_time_cannot_be_earlier_than_3_minutes_from: "",
  inspection_template: "",
  inspection_type: "",
  install: "",
  installation_position: "",
  installing: "",
  install_failed_click_to_install_again: "",
  install_firmware: "安装固件",
  install_now: "立即安裝",
  install_on_non_system_disk_or_run_as_administrator:
    "請將軟體安裝在非系統盤或以管理員許可權運行此軟體",
  install_success_click_to_restart: "",
  instruction_issued_successfully: "",
  insufficient_device_battery_level: "設備電池電量不足",
  insufficient_device_space: "設備空間不足",
  insufficient_disk_pls_clean: "磁片空間不足，請清理磁片",
  insufficient_disk_space: "硬盤不足",
  insufficient_memory: "內存不足",
  insufficient_storage_space_alarm: "",
  insulation_sheet: "絕緣片",
  integrated_judgment_switch_settings: "綜合研判開關設置",
  intelligent_analysis: "智能研判",
  intelligent_analysis_level: "智能研判等級",
  intelligent_analysis_result: "智能研判結果",
  intelligent_application: "智能應用",
  intelligent_import: "智能導入",
  intelligent_import_successful: "智能導入成功",
  interface_access_failed: "",
  interface_access_timeout: "",
  internal: "時間間隔",
  interpupillary_distance_adjustment_range: "",
  interval: "間隔",
  interval_period_days: "間隔周期（天）",
  intg_assess_settings: "綜合研判設置",
  introduction: "",
  invalid_atmospheric_temp: "環境溫度無效",
  invalid_distance: "距離無效",
  invalid_email_address: "",
  invalid_emissivity: "發射率無效",
  invalid_ftp_connection: "",
  invalid_ip: "",
  invalid_ip_address: "ip地址不合法",
  invalid_ip_or_mac_address: "ip或mac地址不合法",
  invalid_mac_address: "mac地址不合法",
  invalid_recording_plan_id: "無效的錄影計畫id",
  invalid_reflected_temp: "反射溫度無效",
  invalid_transmittance: "透射率無效",
  invalid_user: "不合法用戶",
  inventory: "",
  inventory_analysis: "",
  in_auto_mode_now_pls_switch_to_other_modes_for_calibration:
    "當前自動檔，請切換至其他檔位進行標定！",
  in_extreme_cases_pls: "極端情況請",
  in_progress: "",
  in_statistics: "統計中",
  in_stock: "",
  in_the_device_option_settings_privacy_imgs_pls_allow_this_app_to: "",
  in_transition: "轉換中",
  in_use: "在用",
  iot_device: "物聯網設備",
  iot_threshold_settings: "物聯閾值設置",
  io_alarm: "IO報警",
  io_alarm_name: "IO報警名稱",
  io_channel: "IO通道",
  io_channel_no: "IO通道編號",
  io_device: "IO 設備",
  io_linkage: "聯動IO",
  io_settings: "IO設置",
  io_status: "IO設備狀態",
  ipc_event_popup: "IPC事件彈窗",
  ipc_popup_switch: "IPC彈窗開關",
  ip_address: "IP地址",
  ip_address_required: "IP地址(必填)",
  ip_already_exists: "IP已存在",
  ip_error: "IP有誤",
  ip_information: "IP資訊",
  ip_is_required: "IP不能為空",
  ip_or_url: "IP或網址",
  ip_whitelist: "IP白名單",
  ir: "紅外",
  iron: "鐵紅",
  irt_vms: "",
  ir_detector: "",
  ir_discovery: "睿探",
  ir_farm_tech: "",
  ir_farm_tech_comprehensive_cloud_platform_all_rights_reserved: "",
  ir_farm_tech_comprehensive_management_cloud_platform: "",
  ir_farm_tech_robot_management_cloud_platform: "",
  ir_img: "紅外圖片",
  ir_mode: "紅外模式",
  ir_setting: "",
  ir_threshold_settings: "紅外閾值設置",
  isotherm: "等溫線",
  isothermal: "等溫帶",
  isothermal_setting: "等溫帶設置",
  isotherm_cannot_be_enabled_in_non_inf_mode: "非紅外模式下不允許開啟等溫線",
  isotherm_cannot_be_enabled_in_white_hot_or_black_hot_mode:
    "白熱、黑熱偽彩模式下不允許開啟等溫線",
  isotherm_disabled: "等溫線功能已關閉",
  isotherm_off: "等溫線：關",
  isotherm_on: "等溫線：開",
  isotherm_switch: "等溫線開關",
  issue: "",
  issued_successfully: "",
  italian: "義大利語",
  its_empty_here: "",
  it_can_be_expanded_to_more_than_1000_channels_by_re_licensing:
    "可通過重新授權，擴展至1000路以上",
  it_is_recommended_to_input_n1_sets_of_data_or_more_distribute_th:
    "建議輸入{n1}組及以上數據，觀測目標盡可能分散，最大雲臺轉角差異最好為{n2}度",
  ivs: "算法盒子",
  ivs_box_channel_id: "盒子通道編號",
  i_have_read_and_agree: "",
  i_know: "",
  jan: "一月",
  japanese: "日語",
  join_the_company: "",
  judgment_rule_identifier_cannot_be_empty: "研判規則標識不能為空",
  judg_ch_assoc_plan: "研判通道關聯計畫",
  judg_rule_settings: "研判規則設置",
  jul: "七月",
  jun: "六月",
  jungle: "",
  just_browsing: "",
  just_now: "",
  keep_close_to_the_device_and_make_sure:
    "請靠近設備，確保設備已連上手機熱點或在一個局域網",
  keep_close_to_the_device_and_select_one:
    "請靠近設備並選擇以下任一方式進行設備連接",
  kelvin: "開爾文",
  keywords: "關鍵字",
  kg_head: "",
  knight_blue: "",
  knot: "節",
  korean: "韓語",
  language: "語言",
  language_option: "語言選擇",
  language_switch_is_valid_after_software_restart: "語言切換重啟後生效",
  laser: "",
  laser_range_finder: "",
  laser_range_finding: "",
  lastest_inspection_time: "",
  last_24_hours: "",
  last_48_hours: "",
  last_72_hours: "",
  last_connection_time: "",
  last_inspection_time: "",
  last_login_ip: "",
  last_login_time: "",
  last_month: "最近一個月",
  last_occurrence: "最近一次",
  last_seven_days: "",
  last_six_months: "",
  last_three_days: "",
  last_three_months: "最近三個月",
  last_updated_time: "",
  last_week: "最近一周",
  latitude: "緯度",
  latitude_and_longitude: "經緯度",
  latitude_cannot_be_empty: "緯度不能為空",
  latitude_out_of_current_map_area: "緯度超出當前地圖區域",
  latitude_required: "緯度(必填)",
  lava: "熔岩",
  layer: "圖層",
  layer1: "",
  layer_may_exist: "",
  layer_sel: "圖層選擇",
  layout: "佈局",
  led_alarm: "LED報警",
  led_light_malfunction: "",
  left: "左",
  left_hand_twist: "",
  left_hand_twist_right_hand_twist: "",
  left_right_flip: "左右翻轉",
  left_side: "",
  left_side_device_status: "",
  legal_disclaimer: "法律聲明",
  length_must_be_between_6_to_20_characters: "",
  length_must_not_exceed_20_characters: "長度不得超過20個字元",
  lens_config: "鏡頭配置",
  lens_obstruction: "",
  lens_offset: "",
  less_than: "小於",
  level: "級別",
  level1: "一級",
  level2: "二級",
  level3: "三級",
  level4: "四級",
  level_span: "溫寬拉伸",
  lift: "",
  lifting_height: "",
  lifting_pole: "",
  lifting_rod_information: "",
  lifting_strategy: "",
  lift_control: "",
  lift_rod_anomaly: "",
  lift_to: "",
  light_aluminium_oxide: "輕度氧化鋁",
  limited_time: "限時",
  limited_time_shield: "限時屏蔽",
  limited_to_20_characters: "限製20個字",
  limit_of_100_characters: "限製100個字符",
  line: "線",
  line_chart: "折線圖",
  line_number_reach_limit: "線測溫數量達到上限",
  linkage: "聯動",
  linkage_channel: "聯動通道",
  linkage_control: "普通預覽",
  linkage_recording: "聯動錄影",
  linkage_record_directory: "聯動錄影路徑",
  linkage_record_duration: "聯動錄影時長",
  linkage_snapshot: "聯動抓圖",
  linkage_snapshot_directory: "聯動抓拍路徑",
  linkage_sound: "聯動聲音",
  linkage_strategy_setting_successful: "聯動策略設置成功",
  linked_data_exists_and_deletion_is_not_supported: "",
  linked_devices: "聯動設備",
  linked_device_not_set: "未設置聯動設備",
  linked_ptz_name: "聯動雲臺名稱:",
  link_alarm_refresh: "重繪聯動報警",
  link_alarm_refresh_time: "聯動報警重繪時間",
  link_snapshot_path: "聯動抓圖路徑",
  live: "實時視頻",
  livestock_egg_laying_chickens: "",
  livestock_fattening_pigs: "",
  livestock_meat_chickens: "",
  live_preview: "即時預覽",
  lo: "低溫設置",
  loading: "加載中",
  loading_pls_wait: "加載中，請稍候...",
  load_failed: "加載失敗",
  load_succeeded: "",
  local_device: "本地設備",
  local_file: "本地文件",
  local_file_verification_failed: "",
  local_import: "本地導入",
  local_platform_code: "本級平臺編碼",
  local_platform_name: "本級平臺名稱",
  local_resource: "本地資源庫",
  locate_failed_pls_try_again_later: "",
  location: "位置",
  location_permi_required: "",
  location_permi_required_to_discover_new_devices: "",
  location_permi_required_to_obtain_gps_data: "",
  lock: "鎖定",
  locked: "",
  lock_failed: "鎖定失敗",
  lock_robot: "",
  lock_succeeded: "鎖定成功",
  lock_the_robot: "",
  log: "",
  login: "登錄",
  login_account: "",
  login_again: "",
  login_attempts_are_too_frequent_pls_try_again_in_1_minute: "",
  login_expired_pls_log_in_again: "登錄過期，請重新登錄",
  login_failed: "登錄失敗",
  login_success: "登錄成功",
  logout: "退出",
  logout_successful: "登出成功",
  logo_setting: "Logo設置",
  log_query: "日誌查詢",
  longitude: "經度",
  longitude_cannot_be_empty: "經度不能為空",
  longitude_out_of_current_map_area: "經度超出當前地圖區域",
  longitude_required: "經度(必填)",
  long_distance_pedestrian_warning: "",
  long_distance_vehicle_warning: "",
  loop_task_already_exists: "",
  low: "低",
  lower_threshold: "閾值下限",
  low_battery: "電池電量低！",
  low_battery_alarm: "",
  low_battery_threshold: "",
  low_frequency: "",
  low_gain: "低增益",
  low_highlight: "低溫凸顯",
  low_temp: "低溫閾值",
  low_temperature: "低溫",
  low_temperature_high_temperature: "低溫溫度值需小於高溫溫度值",
  low_temp_equal_to: "低溫等於",
  low_temp_mode: "低溫檔",
  low_temp_value: "低溫值",
  l_of_rule_n_cannot_be_empty: "規則{n}的{l}不能為空",
  m: "分",
  machine_code_cannot_be_empty: "機器碼不能為空",
  mac_address: "",
  mac_whitelist: "MAC白名單",
  magnification: "",
  maintenance_due_time: "維護到期時間",
  main_application: "主應用",
  main_stream: "主碼流",
  male: "",
  management: "管理",
  management_and_config: "管理與配置",
  manager: "超級管理員",
  manual: "手動",
  manual_adjustment: "",
  manual_analysis_level: "人工研判等級",
  manual_control: "",
  manual_event: "",
  manual_events_are_only_stored_on_the_device_if_you_want_to_save_: "",
  manual_excl: "手動剔除",
  manual_focus: "",
  manual_follow: "手動跟隨",
  manual_layer_labeling: "手動標注圖層",
  manual_markup_layer_not_displayed_pls_display_it_in_layer_sel:
    "手動標注圖層未展示，請至圖層選擇處展示該圖層",
  manual_mode: "",
  manual_time_calibration: "",
  manual_time_sync_set_successfully: "",
  manufacturer: "",
  manufacturer_list: "",
  manufacturer_name_already_exists_pls_edit_again: "",
  man_overboard_detection: "落水人員檢測",
  map: "",
  map_config: "",
  map_display: "",
  map_management: "",
  map_name: "",
  map_name_cannot_be_empty: "",
  map_name_should_consist_of_letters_numbers_or_chinese_characters: "",
  map_survey: "",
  map_sync_failed_network_connection_abnormal: "",
  map_update_failed: "",
  map_ver_number_or_point_ver_number_update_failed: "",
  mar: "三月",
  marble: "大理石",
  marker: "",
  marking_area: "標面",
  marking_line: "標線",
  marking_point: "標點",
  markup_information: "標注信息",
  material: "材料",
  matte_paint: "非亮漆",
  max: "最高溫",
  maximize: "最大化",
  max_10_linkage_channels: "聯動通道數量最多為10個",
  max_alarm_data_retention_period: "報警數據最大保存天數",
  max_count_per_cage: "",
  max_egg_production: "",
  max_egg_production_rate: "",
  max_number_of_files_that_can_be_seled: "",
  max_number_of_intelligent_judgment_repetitions: "智能研判最大重複次數",
  max_number_of_intelligent_judgment_repetitions_cannot_be_empty:
    "智能研判最大重複次數不能為空",
  max_number_of_temp_difference_rules_is: "溫度差值規則最大數量為",
  max_offset_cannot_be_empty: "最大偏移量不能為空",
  max_offset_m: "最大偏移量(米)",
  max_of_0_resources_allowed_currently_1_resources_exist:
    "資源總數最多{0}條，目前已有{1}條",
  max_of_1000_resources_allowed_currently_1000_resources_exist:
    "資源總數最多1000條，目前已有1000條",
  max_of_8_imgs_are_seled: "",
  max_sel_quantity: "最大選擇數量",
  max_temp: "最大溫度",
  max_temp_big_than: "最高溫大於",
  max_temp_big_than_min_temp: "最高溫必須大於最低溫",
  max_temp_is_required: "最高溫不能為空",
  max_temp_less_than: "最高溫小於",
  max_time_interval: "最大時間間隔",
  max_time_interval_cannot_be_empty: "最大時間間隔不能為空",
  may: "五月",
  mearge_alarm_export: "合並報警導出",
  measurement: "測量設置",
  measurement_range: "測溫範圍",
  measure_area: "測面",
  meat_chicken_customer_administrator: "",
  media_format: "媒體格式",
  media_library: "媒體庫",
  medical: "醫療",
  medical_transport_vessel: "醫療運輸船",
  medium: "中",
  menu: "",
  menu_management: "功能表管理",
  menu_name: "菜單名稱",
  menu_permissions: "菜單權限",
  menu_route: "菜單路由",
  menu_url: "菜單URL",
  merge: "合並",
  merge_alarm: "合並報警",
  merge_failed: "合並失敗",
  merge_repeated_alarms: "合併重複報警",
  merge_time_interval_s: "合併時間間隔(s)",
  merging: "合並中",
  messagebox: "消息框",
  message_prompt: "消息提示",
  message_push: "",
  message_queue_exception: "訊息佇列異常",
  metal: "",
  meter: "米",
  methane: "甲烷",
  method_1: "方式一",
  method_2: "方式二",
  method_3: "方式三",
  microphone: "",
  microservice_invocation_exception: "調用微服務異常",
  middleware_ver: "",
  midgrey: "中灰",
  military_opes_vessel: "軍事作業船",
  min: "最低溫",
  mine: "我的",
  minimize: "最小化",
  minor: "",
  minutes: "分鐘",
  minutes_15: "15分鐘",
  minutes_30: "30分鐘",
  min_15_seconds_for_linkage_recording_duration: "聯動錄影時長最少15秒",
  min_ago: "",
  min_data_collection_period_is_5_minutes: "資料獲取週期最少5分鐘",
  min_egg_production: "",
  min_egg_production_rate: "",
  min_temp: "最小溫度",
  min_temp_big_than: "最低溫大於",
  min_temp_is_required: "最低溫不能為空",
  min_temp_less_than: "最低溫小於",
  mirage: "幻彩",
  mirror_display: "",
  mirror_img: "",
  missed_cage_report: "",
  missed_coop_report: "",
  missed_inspection_report: "",
  missed_report_entry: "",
  missed_report_img: "",
  mmenu: "菜單",
  mmsi: "海上移動業務識別碼",
  mobile: "手機號碼",
  mobile_binding_successful: "",
  mobile_login: "",
  mobile_number_binding: "",
  mobile_number_changed_successfully: "",
  mobile_number_format_error: "",
  mobile_number_not_bound_unable_to_modify_via_phone_verification: "",
  mobile_phone_imei: "",
  mobile_robot: "",
  mobile_verification_modification: "",
  mode: "模式",
  model: "型號",
  model_confirmed_reboot_soon: "確定型號，即將重啟",
  moderate: "",
  mode_setup: "",
  mode_switching_failed_due_to_no_mode_seled_or_incorrect_mode_sel: "",
  modification_failed: "修改失敗",
  modify: "修改",
  modify_alias: "修改別名",
  modify_all: "",
  modify_area: "修改區域",
  modify_cage: "",
  modify_config: "",
  modify_data_permi: "",
  modify_department: "",
  modify_device_name: "修改設備名稱",
  modify_house: "",
  modify_map: "",
  modify_organization: "",
  modify_point: "",
  modify_push_notification_personnel: "修改推送人員",
  modify_pwd: "修改密碼",
  modify_role: "",
  modify_success: "修改成功",
  modify_template: "",
  modify_the_same_channel: "",
  modify_this_point_only: "",
  modify_time: "修改時間",
  modify_user: "",
  module: "",
  module_temperature: "",
  monday: "週一",
  monitoring_description: "",
  monitoring_devices: "",
  monitoring_device_details: "監控設備詳情",
  monitoring_end_time: "",
  monitoring_frequency: "",
  monitoring_handling_time: "",
  monitoring_range_layer: "監控範圍圖層",
  monitoring_record: "",
  monitoring_records: "",
  monitoring_record_processing: "",
  monitoring_screen: "",
  monitoring_start_time: "",
  monitoring_type: "",
  month: "月",
  monthly: "",
  monthly_alarm_count: "",
  more: "更多",
  morning: "",
  motion_detection: "移動檢測",
  motor: "",
  motor_anomaly: "",
  motor_information: "",
  motor_malfunction: "",
  mounted_equipment: "",
  mouse_follow: "滑鼠跟隨",
  move_down: "下移",
  move_down_failed: "下移失敗",
  move_failed: "移動失敗",
  move_to: "移動到…",
  move_to1: "",
  move_up: "上移",
  move_up_failed: "上移失敗",
  ms_word_required: "注意：PDF類型需先安裝MS-Word",
  multichannel: "多通道",
  multi_frame_occurrence_confidence_threshold: "多幀/次可信閾值",
  mute_alarm_sound: "屏蔽報警聲音",
  mute_notifications: "",
  mute_notifications_setting_succeeded: "",
  mute_notifications_time: "",
  muzzle_velocity: "",
  mysubmailcom: "賽郵雲",
  my_coupon: "",
  my_equipment: "",
  my_order: "",
  my_patrol: "我的輪巡",
  my_view: "我的視圖",
  m_serial: "M系列",
  n1_an_inspection_task_is_being_delivered: "",
  n1_inspection_task_is_resuming: "",
  n1_inspection_task_is_re_executing: "",
  n1_inspection_task_resumption_execution_failed_network_connectio: "",
  n1_inspection_task_resumption_succeeded: "",
  n1_inspection_task_re_execution_failed_network_connection_error: "",
  n1_inspection_task_re_execution_failed_robot_unresponsive: "",
  n1_inspection_task_re_execution_succeeded: "",
  n1_the_inspection_task_fails_to_be_delivered_and_the_n2_robot_do: "",
  n1_the_inspection_task_fails_to_be_delivered_because_the_point_o: "",
  n1_the_inspection_task_fails_to_be_restarted_because_the_n2_robo: "",
  n1_the_inspection_task_fails_to_be_restored_and_the_n2_robot_doe: "",
  n1_the_inspection_task_fails_to_be_terminated_and_the_n2_robot_d: "",
  n1_the_inspection_task_fails_to_be_terminated_because_the_networ: "",
  n1_the_inspection_task_is_delivered_successfully: "",
  n1_the_inspection_task_is_terminated: "",
  n1_the_inspection_task_is_terminated_successfully: "",
  name: "名稱",
  names_can_only_contain_chinese_characters_numbers_english_and_:
    "名稱僅允許輸入漢字、數位、英文、“-”、“_”",
  name_already_exists: "名稱已存在",
  name_already_exists_pls_enter_a_new_name: "已有該名稱，請重新填寫名稱",
  name_is_required: "名稱不能為空",
  name_must_be_less_than_10: "名稱需小於10",
  national_sip_domain: "國標SIP域",
  navigate_to_this_location: "導航到這",
  navigation_camera: "",
  navigation_camera_illuminator: "",
  navigation_camera_information: "",
  navigation_point: "",
  near_focus: "近焦",
  need_to_access_your_camera_to_capture_imgs: "",
  need_your_permission_to_access_the_album:
    "需要您的同意，才能訪問相冊。若不允許,您將無法將圖片或視頻保存到本地相冊",
  network_abnormal_login_failed: "",
  network_communication_error_xxx_inspection_task_generation_faile: "",
  network_congestion: "網路擁擠",
  network_connection_timed_out: "網路連接逾時",
  network_device: "網路設備",
  network_exception_pls_check_the_network_settings:
    "網路連接異常，請檢查網路設置",
  network_issue_download_interrupted: "網路原因，下載中斷",
  network_name: "網絡名稱",
  network_or_service_exception_pls_check_and_retry:
    "網路或服務異常，請檢查後重試",
  network_setup: "網路設置",
  network_status: "網路狀態",
  never_end: "永不結束",
  newdual_targetkb: "新-雙目標定",
  newly_added_today: "",
  newsingle_targetkb: "新-單目標定",
  new_alarms_today: "",
  new_firmware_ver_detected_for_this_device_would_you_like_to_upgr:
    "檢測到該設備有新固件版本，是否升級",
  new_name: "",
  new_page: "新增頁面",
  new_password_cannot_be_the_same_as_old_password: "",
  new_pwd: "新密碼",
  new_pwd_is_required: "新密碼不能為空",
  new_ver_exist: "有新版本",
  new_ver_found: "",
  next: "下一步",
  next_frame: "下一幀",
  next_page: "下一頁",
  next_point: "",
  nickname: "",
  nickname_not_set: "",
  night: "",
  no: "否",
  none: "無",
  non_administrators_cannot_add_linkage_strategies: "非管理員無法添加聯動策略",
  non_admin_users_cannot_del_linkage_strategies: "非管理員無法刪除聯動策略",
  non_armed_conflict_state_ships_and_aircraft: "非武裝沖突國家船和飛行器",
  non_car: "非汽車",
  non_excavator: "非挖掘機",
  non_fire: "非火災",
  non_laying_hens: "",
  non_laying_hen_analysis: "",
  non_preset: "非預置位",
  non_productive_chicken_alarm: "",
  non_standard_inf_file: "",
  normal: "",
  note: "備註",
  noteclick_this_button_then_click_on_the_map_to_draw_the_area:
    "說明：點擊該按鈕後，在地圖點擊進行區域繪製。",
  note_excluding_coriolis_effect_from_calculations: "",
  note_if_you_want_to_add_new_personnel_and_alarm_sources_pls_set_:
    "提示：已設置報警如果要添加新的人員和報警源，請在修改頁面設置",
  note_the_robot_can_only_issue_one_loop_task_and_loop_tasks_canno: "",
  notice: "通知公告",
  notification_channel: "",
  notification_channel_setting: "",
  notification_method: "告知方式",
  notification_personnel: "告知人員",
  not_added: "未添加",
  not_a_false_alarm: "非誤報",
  not_binding_for_now: "",
  not_calibrated: "未校準",
  not_connected: "未連接",
  not_connected_to_original_device: "未連接到原始設備",
  not_executed: "",
  not_filled_in: "",
  not_null: "不可為空",
  not_online: "網絡未連接",
  not_picked: "",
  not_supported: "不支持",
  not_upgrading_for_now: "暫不升級",
  not_yet_added_temp_measurement_area: "還未添加測溫區域",
  nov: "十一月",
  no_account: "",
  no_alarm: "",
  no_alarms: "暫無報警",
  no_anomaly: "",
  no_available_channels_found_pls_check_the_device:
    "未發現可用通道，請檢查設備",
  no_available_location_provider: "",
  no_base_map: "暫無底圖",
  no_column_currently_requires_synchronizing_age_in_days: "",
  no_content: "暫無內容",
  no_data: "無數據",
  no_data_available: "",
  no_data_exported: "沒有導出數據",
  no_data_reported_by_robot: "",
  no_devices_connected: "",
  no_devices_seled_or_devices_under_the_organization_not_loaded:
    "未選中設備或組織下的設備未載入",
  no_device_detected_if_no_device_is_connected_for_a_long_time_pls: "",
  no_device_found_nearby: "",
  no_device_info: "無設備資訊",
  no_downloads_yet: "",
  no_file: "暫無檔",
  no_files: "該設備沒有文件",
  no_files_selected: "無選中檔",
  no_files_seled_for_download: "",
  no_flip: "不翻轉",
  no_highlight: "不凸顯",
  no_image_to_analyze: "沒有可分析的圖片",
  no_inspection_points_in_the_map_associated_with_this_robot: "",
  no_inspection_results: "",
  no_inspection_tasks: "",
  no_installation_permi: "",
  no_linkage_chan: "暫無聯動通道",
  no_linkage_strategy_information_found: "未查詢到聯動策略資訊",
  no_more_data: "",
  no_more_data_available: "",
  no_offline_information_for_this_device: "沒有該設備的離線資訊",
  no_off_not_allowed_during_linkage_recording:
    "有通道聯動錄影中，不可開啟或關閉",
  no_other_streams: "無其他碼流",
  no_pdf: "暫無PDF",
  no_permission: "沒有許可權",
  no_permi_to_access_this_video_stream_or_recording:
    "無訪問該視頻流或錄影的許可權",
  no_photo: "暫無圖片",
  no_photos_in_sd_card: "Sd卡中沒有圖片！",
  no_playback: "無回放",
  no_preview: "無預覽",
  no_preview_of_panoramic_window_found: "沒有發現正在預覽的全景視窗",
  no_processing_template: "無處理模板",
  no_prompt: "",
  no_ptz_control_permi_pls_contact_the_administrator_for_config:
    "無雲臺控制權限，請聯繫管理員配置。",
  no_push_recipients: "無推送人",
  no_real_time_preview_permi_pls_contact_the_administrator_for_con:
    "無即時預覽許可權，請聯繫管理員配置",
  no_recording: "沒有錄影",
  no_relevant_locations_found: "沒有找到相關地點",
  no_robot_associated: "",
  no_rule: "無規則",
  no_sdcard: "Sd卡未插入",
  no_signal: "無信號",
  no_snapshot: "沒有抓圖",
  no_statistics_data: "沒有統計數據",
  no_storage_permi: "",
  no_strategies_submitted_ope_failed: "未提交任何策略，操作失敗",
  no_strategy_seled_for_deletion: "未選中需要刪除的策略",
  no_such_recording: "無此錄影",
  no_task_template: "",
  no_task_templates_available: "",
  no_temp_video_recording_in_visible_mode: "可見光模式不支持溫度視頻錄製",
  no_track_information_for_this_individual: "該人員無軌跡信息",
  no_update_directory_detected: "",
  no_video: "暫無視頻",
  no_videos_during_the_seled_time_period: "所選時間段內無視頻",
  ntp_port: "",
  ntp_time_calibration: "",
  num: "拍攝張數",
  number_of_alarm_snapshots: "報警抓拍張數",
  number_of_bound_firearms: "",
  number_of_broken_eggs: "",
  number_of_cages_with_dead_chickens: "",
  number_of_cage_columns: "",
  number_of_chickens: "",
  number_of_chicken_cages: "",
  number_of_chicken_cage_layers: "",
  number_of_connected_devices: "已接入數量",
  number_of_dead_chicken_cages: "",
  number_of_eggs: "",
  number_of_eggs_produced: "",
  number_of_failed_tasks_today: "",
  number_of_failures: "",
  number_of_laying_hens: "",
  number_of_online_devices: "在線設備數量",
  number_of_pigs: "",
  number_of_pigs_heads: "",
  number_of_tasks_completed_today: "",
  number_of_times: "持續次數",
  number_order: "序號",
  numeric_or_rate_val_cannot_be_empty: "",
  observation: "觀察",
  observation_distance: "觀測距離",
  obsidian_black: "",
  obtaining_device_config: "",
  obtain_verification_code: "獲取驗證碼",
  obtain_via_bluetooth_device: "",
  oct: "十月",
  odometer_information: "",
  odom_anomaly: "",
  off: "關",
  offline: "離線",
  offline_analysis: "離線分析",
  offline_analyzed_and_cannot_be_deleted: "此視頻正在離線分析，不可刪除",
  offline_status_setting_failed: "設置離線狀態失敗",
  ok: "確定",
  old_password: "",
  old_password_cannot_be_empty: "",
  on: "開啟",
  once_only: "",
  once_the_algorithm_judgment_begins_alarms_with_repeated_occurren:
    "開始進入演算法研判後，重複報警次數小於等於【重複報警次數閾值+該閾值】的報警將被連續觸發AI識別",
  one_click_clear: "一鍵清空",
  one_click_import: "",
  one_click_preview: "一鍵預覽",
  one_click_return_to_charging_pile: "",
  one_click_return_to_charging_pile_failed: "",
  one_cropping_task_is_running_do_you_want_to_exit_the_program:
    "當前有尚未完成的視頻導出任務，關閉軟體後該任務將自動取消，確定退出嗎",
  one_cropping_task_is_running_pls_wait: "一個裁剪任務正在進行，請稍等",
  one_week_ago: "一周前",
  ongoing: "",
  online: "線上",
  online_analysis: "線上分析",
  online_ratio: "線上比例",
  only_allow_drawing_areas_with_3_or_more_points: "只允許繪製3個點及以上區域",
  only_available_in_inf_mode_except_for_black_hot_and_white_hot_ps:
    "僅在紅外模式下可用（除黑熱、白熱以外偽彩）",
  only_csv_files_allowed: "只允許上傳csv檔!",
  only_dead_chickens: "",
  only_jpg_png_jpeg_files_can_be_uploaded_and_no_larger_than_500kb: "",
  only_numbers: "",
  only_one_device_can_be_seled: "只能選擇一個設備",
  only_one_file_can_be_renamed_at_a_time: "每次僅可以重命名一份檔",
  only_one_image_can_be_shared_at_a_time: "每次僅可分享一張圖片",
  only_today: "",
  only_upload_imgs_in_jpg_jpeg_bmp_tif_png_formats:
    "只能上傳jpg、jpeg、bmp、tif、png格式的圖片",
  onvif_protocol: "ONVIF協議",
  on_site_pictures: "",
  opaque_plastic: "不透明塑料",
  open: "打開",
  openid_error: "openId錯誤",
  opening_bank: "",
  open_a_local_file: "打開本地文件",
  open_device: "打開設備",
  open_device_for_firmware_upgrade: "打開設備進行固件升級",
  open_directory: "打開目錄",
  open_factory_password: "",
  open_failed: "打開失敗",
  open_file: "打開文件",
  open_file_failed: "檔打開失敗",
  open_folder: "打開所在檔夾",
  open_source_component_license: "開源組件許可",
  open_source_software_license: "開源軟體許可證",
  open_source_software_licenses: "開源聲明",
  open_wifi: "",
  operating_channel_sel: "運行通道選擇",
  operation: "操作",
  operation_temperature_range: "",
  operator: "操作員",
  opes_are_too_frequent: "操作頻率過快。",
  opes_center: "運維中心",
  opes_information: "",
  opes_too_frequent_pls_try_again_later: "",
  ope_and_maintenance_management: "",
  ope_and_maintenance_monitoring: "",
  ope_and_maintenance_record: "",
  ope_behavior: "",
  ope_details: "",
  ope_failed: "操作失敗",
  ope_information: "操作資訊",
  ope_information_only_includes_the_robots_own_status_data_used_on: "",
  ope_logs: "",
  ope_monitoring: "",
  ope_permis: "",
  ope_prohibited: "",
  ope_succeeded: "操作成功",
  ope_time: "",
  ope_too_frequent_pls_try_again_later: "",
  optional: "",
  opt_img: "可見光圖片",
  order: "",
  order_appraise: "",
  order_channel: "",
  order_info: "",
  order_number: "",
  order_of_temp_rise_threshold_is_wrong: "各級別溫升閾值順序有誤",
  order_of_temp_threshold_is_wrong: "各級別溫度閾值順序有誤",
  order_status: "",
  ordinary_recording_mode: "普通錄像模式",
  organization: "所屬組織",
  organizational_settings: "組織機構設置",
  organization_administrator: "",
  organization_cannot_be_empty: "",
  organization_does_not_exist_pls_download_the_latest_template:
    "組織機構不存在，請下載最新範本",
  organization_id: "組織機構ID",
  organization_information: "",
  organization_name: "組織名稱",
  organization_name_cannot_be_empty: "",
  organization_name_must_be_letters_numbers_or_chinese_characters_: "",
  organization_not_enabled_unable_to_log_in: "",
  organization_remarks: "",
  organization_required: "所屬組織(必填)",
  organization_type: "",
  organization_type_error: "",
  original_frame: "設備原始幀頻",
  original_pwd: "原密碼",
  original_pwd_is_required: "原密碼不能為空",
  osd: "網板疊加",
  oss_get_error: "oss訪問信息獲取失敗,請重新登錄",
  other: "其他",
  other_features: "",
  other_img: "其他圖片",
  other_reasons: "",
  other_setting: "其它設置",
  other_types: "其他類型",
  outdoor: "",
  outline: "勾邊",
  overlay_traj_point_count: "疊加軌跡點數",
  p: "張",
  page: "頁",
  page_permis: "",
  palette: "偽彩設置",
  panorama: "全景圖",
  panoramic_area_intrusion: "全景區域入侵",
  panoramic_device_config: "全景設備配置",
  panoramic_event_popup: "全景事件彈窗",
  panoramic_popup_switch: "全景彈窗開關",
  pan_angle: "",
  pan_angle_must_be_an_integer_within_0_360: "",
  pan_tilt_control_failed: "雲台控制失敗",
  pan_tilt_control_request_failed: "雲台控制請求失敗",
  pan_tilt_position_not_recorded_in_event_log: "事件記錄未記錄雲台位置",
  paper: "紙",
  parameters: "參數",
  parameters_cannot_be_empty: "參數不能為空",
  parameters_cannot_be_repeated: "",
  parameter_error: "參數錯誤",
  parameter_missing_addition_failed: "參數缺失，添加失敗",
  parameter_setting: "參數設置",
  parameter_validation_failed: "參數校驗失敗",
  parent_child_linkage: "",
  parent_department: "",
  parent_department_cannot_be_empty: "",
  parent_directory: "上級目錄",
  parent_menu: "上級菜單",
  passenger_ship: "客船",
  passwords_do_not_match: "",
  passwords_entered_do_not_match: "",
  password_changed_successfully: "",
  password_changed_successfully_pls_log_in_again: "",
  password_format_should_be_letters_and_numbers_with_a_length_of_8: "",
  password_length_is_less_than_10: "密碼長度需小於10",
  password_login: "密碼登錄",
  password_required: "密碼(必填)",
  password_reset_successful: "",
  paste: "粘貼",
  path: "",
  path_length_exceeds_256_characters: "路徑長度超出256字符",
  path_to_open_files: "打開檔夾路徑",
  patrol: "巡邏",
  patrol_fast_backward: "輪巡快退",
  patrol_fast_forward: "輪巡快進",
  patrol_track: "",
  pause: "暫停",
  pause_manual_control: "",
  pause_patrol: "暫停輪巡",
  pause_recharging: "",
  pay: "",
  payment_channel: "",
  pay_success: "",
  pdf_library: "PDF庫",
  pebble: "石子",
  pedestrian_animal_alarm: "",
  pedestrian_target_frame_display: "",
  pending_alarms: "",
  pending_outbound: "",
  pen_management: "",
  pen_name_must_be_numbers_or_chinese_characters_and_no_longer_tha: "",
  periodic_time: "週期時間",
  period_setting: "週期設置",
  permanent: "永久",
  permi_character: "",
  permi_character_cannot_be_empty: "",
  permi_character_must_be_chinese_characters_or_letters_and_no_lon: "",
  permi_config: "",
  permi_scope: "",
  personal_information: "",
  personnel_coordinates: "人員座標",
  person_in_charge: "責任人",
  phone: "電話",
  phone_number_cannot_be_empty: "手機號不能為空",
  photos: "照片",
  photo_interval: "拍照間隔",
  photo_setting: "拍照設置",
  photo_taken: "拍照完成",
  picked: "",
  pic_data_error: "圖片數據錯誤",
  piece: "",
  pieces: "",
  pieces_per_hen: "",
  piece_cost: "",
  piece_price: "",
  pigpen_details: "",
  pigsty_data_statistics: "",
  pigsty_management: "",
  pig_age_in_days: "",
  pig_temp_measurement: "",
  "pig_temp_threshold_℃": "",
  pilot_boat: "引航船",
  pip: "畫中畫",
  pip_adjustment: "畫中畫調整",
  pip_mode: "畫中畫模式",
  pip_settings: "",
  pitch: "瀝青",
  pitch_angle: "",
  pitch_angle_information: "俯仰角資訊",
  pitch_angle_must_be_an_integer_within_90_90: "",
  pitch_angle_n_offset: "俯仰角{n}偏移量",
  pitch_angle_offset: "俯仰角偏移量",
  pixel: "",
  place_the_crosshair_on_the_target_and_click_confirm: "",
  plain_text: "普通文本",
  plan_name_required: "計畫名稱不能為空",
  plan_type: "計劃類型",
  plastic_pvc: "塑料(PVC)",
  platform_authorization: "平臺授權",
  platform_cascading: "平臺級聯",
  platform_name: "平臺名稱",
  platform_name_settings: "平臺名稱設置",
  platform_national_code_settings: "平臺國標編碼設置",
  platform_terminates_inspection_task: "",
  play: "播放",
  playback: "回放",
  playback_ended: "重播結束",
  playback_error: "回放有誤",
  playback_failed_pls_refresh_and_load_again: "",
  playback_history: "回放歷史",
  playback_speed: "倍速",
  playback_start_failed: "啟動播放失敗",
  playback_timeout: "播放等待超時",
  play_audio: "播放音頻",
  play_failed: "播放失敗",
  play_list: "播放清單",
  please_calibrate_the_device: "請校準設備",
  please_enter_a_network_name: "輸入網絡名稱",
  please_enter_file_name: "請輸入文件名",
  please_select_a_picture_or_video_to_delete: "請選擇要删除的圖片或視頻",
  please_wait: "請稍候",
  pls_add_at_least_one_view: "請添加至少一個視圖。",
  pls_add_channel: "請添加通道。",
  pls_add_preset: "請添加預置位。",
  pls_add_the_inspection_action_list: "",
  pls_add_view: "請添加視圖",
  pls_check_network_connection: "",
  pls_check_the_mobile_hotspot_and_the_device_connection_status: "",
  pls_check_the_network_connection: "請檢查網路連接",
  pls_check_the_path: "",
  pls_check_the_sms_platform: "請在短信平臺查找",
  pls_check_your_network_and_try_connecting_again: "請檢查網絡後再次連接",
  pls_choose_associated_ir_img: "請選擇關聯紅外圖片",
  pls_clear_device_channels_first: "請先清空設備通道",
  pls_click_here_to_complete_the_shipping_address: "",
  pls_click_the_settings_button_to_add_a_channel: "請在設置中添加通道",
  pls_complete_the_information: "",
  pls_complete_the_shipping_address: "",
  pls_confirm_information_modification: "請確認是否修改資訊",
  pls_confirm_the_password: "",
  pls_confirm_whether_to_modify_the_encryption_type: "",
  pls_confirm_whether_to_modify_the_wifi_name: "",
  pls_confirm_whether_to_modify_the_wifi_password: "",
  pls_connect_the_device: "請鏈接設備",
  pls_connect_the_device_first: "",
  pls_connect_the_hotspot_first: "請先連接設備熱點",
  pls_contact_the_administrator_to_assign_roles: "請聯系管理員分配角色",
  pls_del_after_sel: "",
  pls_del_device_first: "請先刪除設備",
  pls_disable_isotherm_function_first: "請先關閉等溫線功能",
  pls_end_the_stated_tasks_first: "請先結束已經開啓的任務",
  pls_end_the_tasks_in_electric_mode_first: "請先結束電力模式中開啓的任務",
  pls_end_the_tasks_in_general_mode_first: "請先結束通用模式中開啓的任務",
  pls_ensure_device_battery_and_storage_space_are_sufficient:
    "請確保設備電量和存儲空間充足",
  pls_ensure_you_are_connected_to_the_devices_wifi_network:
    "请确保您已经连接至设备Wifi网络",
  pls_enter_abbreviation: "",
  pls_enter_account_name: "",
  pls_enter_administrator: "",
  pls_enter_alarm_device: "",
  pls_enter_an_email: "請輸入郵箱",
  pls_enter_associated_cage_number: "",
  pls_enter_associated_column_number: "",
  pls_enter_associated_point: "",
  pls_enter_associated_task: "",
  pls_enter_a_channel_name: "請輸入通道名稱",
  pls_enter_a_correct_email_address: "",
  pls_enter_a_mac: "請輸入MAC",
  pls_enter_a_name: "請輸入名稱",
  pls_enter_a_new_device_name: "請輸入新設備名稱",
  pls_enter_a_new_password: "",
  pls_enter_a_new_wifi_name: "",
  pls_enter_a_valid_email_address: "",
  pls_enter_a_valid_phone_number: "",
  pls_enter_a_valid_value: "請輸入有效值",
  pls_enter_browser_time: "",
  pls_enter_building_name: "",
  pls_enter_bullet_name: "",
  pls_enter_bullet_notes: "",
  pls_enter_cage_name: "",
  pls_enter_cage_number: "",
  pls_enter_contact_information: "",
  pls_enter_contact_number: "",
  pls_enter_content: "",
  pls_enter_correct_latitude_and_longitude: "請輸入正確的經緯度",
  pls_enter_database_table: "",
  pls_enter_data_permi_field: "",
  pls_enter_data_permi_name: "",
  pls_enter_data_permi_remarks: "",
  pls_enter_day_age: "",
  pls_enter_department_name: "",
  pls_enter_device_name: "",
  pls_enter_dictionary_label: "",
  pls_enter_dictionary_name: "",
  pls_enter_disposal_opinion: "",
  pls_enter_distance_from_origin: "",
  pls_enter_firearm_name: "",
  pls_enter_firearm_notes: "",
  pls_enter_handler: "",
  pls_enter_house_name: "",
  pls_enter_inspection_point: "",
  pls_enter_integers_1_2: "請輸入整數 %1~%2",
  pls_enter_ip_address: "請輸入IP",
  pls_enter_keywords: "請輸入關鍵字",
  pls_enter_lift_height: "",
  pls_enter_map_name: "",
  pls_enter_monitoring_device: "",
  pls_enter_new_phone_number: "",
  pls_enter_ntp_port: "",
  pls_enter_numbers_between_1_2: "請輸入%1~%2之間的數",
  pls_enter_number_of_cage_columns: "",
  pls_enter_number_of_cage_layers: "",
  pls_enter_number_of_cage_rows: "",
  pls_enter_old_password: "",
  pls_enter_operator: "",
  pls_enter_organization_name: "",
  pls_enter_password: "請輸入密碼",
  pls_enter_pen_name: "",
  pls_enter_permi_character: "",
  pls_enter_person_in_charge: "",
  pls_enter_phone_number: "",
  pls_enter_point_name: "",
  pls_enter_point_type: "",
  pls_enter_port: "請輸入端口",
  pls_enter_reason_description: "",
  pls_enter_remarks: "",
  pls_enter_remarks_no_more_than_100_characters: "",
  pls_enter_report_title: "",
  pls_enter_resource_id: "",
  pls_enter_resource_type: "請輸入資源類型",
  pls_enter_robot: "",
  pls_enter_robot_model: "",
  pls_enter_robot_name: "",
  pls_enter_robot_name_or_channel_name_to_filter: "",
  pls_enter_robot_type: "",
  pls_enter_role_name: "",
  pls_enter_scope_notes: "",
  pls_enter_server_address: "",
  pls_enter_sn_code: "",
  pls_enter_task_name: "",
  pls_enter_text_content: "請輸入文本內容",
  pls_enter_the_admin_username_to_create: "",
  pls_enter_the_affiliated_map: "",
  pls_enter_the_affiliated_robot: "",
  pls_enter_the_area_code: "請輸入區域編號。",
  pls_enter_the_association_name_up_to_50_characters: "請輸入關聯名稱,最多50字",
  pls_enter_the_column_number: "",
  pls_enter_the_correct_verification_code: "請輸入正確的驗證碼",
  pls_enter_the_graphic_verification_code: "",
  pls_enter_the_missed_cage_position_in_the_order_of_column_cage_a: "",
  pls_enter_the_new_password_again: "",
  pls_enter_the_password_again: "",
  pls_enter_the_shielded_area_name: "請輸入屏蔽區域名稱",
  pls_enter_the_sms_verification_code: "",
  pls_enter_the_template_name: "",
  pls_enter_the_template_name_first: "請先輸入範本名稱",
  pls_enter_the_users_name_not_exceeding_20_characters:
    "請輸入用戶姓名，不超過20字",
  pls_enter_the_verification_code: "請輸入驗證碼",
  pls_enter_title: "",
  pls_enter_username: "請輸入用戶名",
  pls_enter_users_name: "",
  pls_enter_user_entity_corresponding_field: "",
  pls_enter_user_table_corresponding_field: "",
  pls_enter_verification_code: "請填寫驗證碼",
  pls_enter_wifi_name: "",
  pls_enter_your_account: "",
  pls_enter_your_mobile_number: "",
  pls_enter_your_new_password: "",
  pls_enter_your_original_password: "",
  pls_enter_your_password: "",
  pls_exit_account: "請退出雲賬戶",
  pls_fill_in_a_description_of_more_than_10_characters_so_that_we_: "",
  pls_fill_in_the_angle_val: "",
  pls_fill_in_the_manufacturer: "",
  pls_fill_in_the_remarks: "",
  pls_follow_the_path_below_to_modify_the_mobile_hotspots_password: "",
  pls_go_to_the_area_settings_module_to_add_an_area: "請至區域設置模組添加區域",
  pls_import_task_template: "",
  pls_include_deviceid_in_request_parameters: "請在請求參數中攜帶deviceId參數",
  pls_input: "",
  pls_input_account: "",
  pls_input_correct_phone_number: "",
  pls_input_details: "",
  pls_input_phone_number: "",
  pls_input_price: "",
  pls_input_pwd: "請輸入賬戶密碼",
  pls_input_sequence: "",
  pls_input_serial_number: "",
  pls_input_the_calibrated_temp: "",
  pls_input_the_new_name: "",
  pls_keep_the_device_on: "請保持設備處於開機狀態",
  pls_keep_this_page_open_during_the_upgrade_and_do_not_put_the_ap:
    "設備升級時，請保持該頁面，不要退出該頁面或將APP置於後臺",
  pls_light_the_star: "",
  pls_login_first: "請登錄賬戶",
  pls_log_in_the_cloud_first: "請先登錄雲平臺",
  pls_operate_after_stop_recording: "請停止錄像再操作!",
  pls_plug_in_the_device: "",
  pls_press_again_to_exit: "",
  pls_read_carefully_and_agree_to_the_following_terms: "",
  pls_remove_all_patrols_under_this_group_before_deleting_the_grou:
    "刪除分組前，需移出該分組下的所有輪巡",
  pls_remove_all_views_under_this_group_before_deleting_the_group:
    "刪除分組前，需移出該分組下的所有視圖",
  pls_renew_it_promptly: "請及時續期",
  pls_scan_qr_code: "請掃描二維碼",
  pls_sel: "請選擇",
  pls_select_a_file: "請選擇文件",
  pls_select_device_first: "請先選擇設備",
  pls_select_first: "請先選擇",
  pls_select_media_first: "請先選擇需要上傳的圖片或視頻",
  pls_select_the_device_model: "請選擇設備型號",
  pls_select_the_file_to_analyze_first: "請先選擇可分析的檔",
  pls_select_time_type_again: "請重新調整開始或結束時間",
  pls_sel_alarm_name: "請選擇報警名稱",
  pls_sel_alarm_name_and_export_by_type: "請選擇報警名稱，按類型查詢導出",
  pls_sel_alarm_name_query__export_by_type: "請選擇報警名稱，按類型查詢匯出",
  pls_sel_alarm_source: "請選擇報警源",
  pls_sel_alarm_type: "請選擇報警類型",
  pls_sel_an_alarm_item: "",
  pls_sel_an_organization: "",
  pls_sel_a_file_to_download: "",
  pls_sel_a_robot: "",
  pls_sel_a_type: "",
  pls_sel_category: "",
  pls_sel_channel: "請選擇通道",
  pls_sel_channels_under_the_robot: "",
  pls_sel_data_permi_type: "",
  pls_sel_date: "請選擇日期",
  pls_sel_device_type: "請選擇設備類型",
  pls_sel_end_action: "",
  pls_sel_execution_frequency: "",
  pls_sel_execution_method: "",
  pls_sel_execution_strategy: "",
  pls_sel_fee_mode: "",
  pls_sel_file_format: "請選擇文件格式",
  pls_sel_inspection_point: "",
  pls_sel_inspection_result: "",
  pls_sel_layout: "請選擇布局。",
  pls_sel_linkage_action: "請選擇聯動動作",
  pls_sel_linkage_channel: "請選擇聯動通道",
  pls_sel_monitoring_type: "",
  pls_sel_notification_personnel: "請選擇告知人員",
  pls_sel_point_type: "",
  pls_sel_preview_channel: "請選擇預覽通道",
  pls_sel_region_first: "請先選擇區域",
  pls_sel_start_time: "",
  pls_sel_statistics_rule: "",
  pls_sel_system_time: "",
  pls_sel_target_location_first: "",
  pls_sel_target_point: "",
  pls_sel_task_status: "",
  pls_sel_the_alarm_frequency: "",
  pls_sel_the_alarm_level: "",
  pls_sel_the_alarm_reason: "",
  pls_sel_the_alarm_status: "",
  pls_sel_the_associated_map: "",
  pls_sel_the_associated_robot: "",
  pls_sel_the_charging_point: "",
  pls_sel_the_chicken_coop_first: "",
  pls_sel_the_device_again_for_a_wifi_connection_if_the_connection:
    "請重新選擇設備WiFi進行連接，如果無法連接建議您重啟設備",
  pls_sel_the_inspection_record: "",
  pls_sel_the_record_status: "",
  pls_sel_the_target_inspection_point: "",
  pls_sel_the_user_to_unbind: "",
  pls_sel_time: "",
  pls_share_after_wifi_enabled: "",
  pls_switch_device_network: "請切換設備網路",
  pls_try_again_in_good_network_condition: "",
  pls_try_again_later: "請稍後再試。",
  pls_turn_on_wifi: "請開啟WiFi",
  pls_unbind_the_firearm_before_deleting: "",
  pls_wait: "正在打開圖庫",
  pn_and_sn_is_required: "PN或SN不能為空",
  pn_sn_exists: "PN/SN重複",
  point: "點",
  point_associated_with_inspection_template_deletion_failed: "",
  point_does_not_exist: "",
  point_exists_in_unfinished_tasks_deletion_failed: "",
  point_information: "",
  point_invalid_belonging_map_has_been_deld: "",
  point_list: "",
  point_management: "",
  point_name: "",
  point_name_already_exists_pls_modify_and_try_again: "",
  point_name_cannot_be_empty: "",
  point_name_should_consist_of_letters_numbers_or_chinese_characte: "",
  point_not_associated: "",
  point_order: "",
  point_status_update_failed: "",
  point_sync_failed: "",
  point_sync_failed_network_connection_error: "",
  point_sync_successful: "",
  point_type: "",
  polish: "波蘭語",
  polished_aluminium_or_aluminum_foil: "拋光鋁或鋁箔",
  polished_cast_iron: "拋光鑄鐵",
  polygon: "多邊形",
  port: "端口",
  port_is_required: "端口不能為空",
  port_number: "",
  port_number_must_be_numeric: "",
  port_range_1_65535: "Port range 1-65535",
  port_required: "端口(必填)",
  port_supply_vessel: "港口供應船",
  positioning_3d: "3D定位",
  positioning_3d_failed: "3D定位失敗",
  position_reset: "複位",
  power: "",
  power_supply: "",
  preset: "預置位",
  preset_name: "預置位名稱",
  preset_name_for_this_channel_already_exists_pls_choose_another_n:
    "設備此通道預置位元名稱重複，請更換名稱",
  preset_number: "預置位編號",
  preset_patrol_plan_setting_failed: "預置位巡航計畫設置失敗",
  preset_tour: "預置位巡航",
  press_back_button_to_quit: "退出定時拍照",
  press_enter_to_search: "按回車鍵搜索",
  preview: "預覽",
  preview_failed: "預覽失敗",
  preview_module: "",
  preview_not_supported: "不支持預覽。",
  preview_playback: "預覽和重播",
  previous: "上一步",
  previous_frame: "上一幀",
  previous_inspection_task_not_completed: "",
  previous_page: "上一頁",
  previous_point: "",
  previous_task_incomplete: "",
  pre_upload_failed: "預上傳失敗",
  price: "",
  primary_server_status: "主要伺服器狀態",
  privacy_agreement: "隱私協議",
  privacy_policy: "隱私政策",
  process: "處理",
  processed: "已處理",
  processed_or_not: "是否處理",
  processing: "處理中",
  processing_cast_iron: "加工鑄鐵",
  processing_comments: "處理意見",
  processing_comments_cannot_be_empty: "處理意見不能為空。",
  processing_failed: "處理失敗",
  processing_time: "處理時間",
  processing_user: "處理用戶",
  production_data: "",
  production_report: "",
  production_report_statistics: "",
  production_statistics: "",
  product_: "產品序列號",
  product_added_to_your_cart: "",
  product_collection: "",
  product_does_not_exist: "",
  product_info: "產品資訊",
  product_list: "",
  product_name: "",
  product_number: "產品編號",
  product_temp: "產品溫度",
  profile: "個人中心",
  progress: "進度",
  prompt: "提示",
  proprietary_protocol: "私有協議",
  protocol: "協議類型",
  province: "",
  pseudo_color_config_not_possible_for_the_current_channel:
    "當前通道無法配置偽彩",
  pseudo_color_settings_not_supported_for_the_current_channel:
    "當前通道不支持偽彩設置",
  ptz_adjustment: "",
  ptz_angle: "雲臺轉角",
  ptz_commands: "雲臺指令",
  ptz_control: "雲臺控制",
  ptz_control_failed: "雲臺控製失敗。",
  ptz_mode: "雲臺模式",
  ptz_pitch_angle: "雲臺俯仰角",
  ptz_reset: "雲臺歸零",
  ptz_sensitivity: "PTZ 敏感度",
  ptz_settings: "雲台設定",
  ptz_tracking_failed: "雲台跟隨失敗",
  public_patrol: "公共輪巡",
  public_view: "公共視圖",
  pull_down_to_refresh: "",
  pull_up_to_load: "",
  pull_up_to_show_more: "",
  puor: "紫橙",
  purchase_type: "",
  push_area: "推送區域",
  push_config_settings_succeeded: "",
  push_notification_settings: "推送設置",
  push_successful: "推送成功",
  pwd: "密碼",
  pwd_cannot_be_empty: "密碼不能為空",
  pwd_combination_rules_8_16: "",
  pwd_confirm_is_required: "確認密碼不能為空",
  pwd_control: "密碼管控",
  pwd_error: "密碼錯誤",
  pwd_inconformity: "兩次密碼不一致",
  p_serial: "P系列",
  qa: "",
  qr_code: "二維碼",
  qr_code_number: "",
  qr_code_point: "",
  qr_code_point_retrieval_failed: "",
  qr_code_point_retrieval_successful: "",
  quantity: "",
  quantity_up_to_limit: "",
  query: "",
  query_current_robot_inspection_progress_successful: "",
  query_record_is_empty: "查詢記錄為空",
  query_time: "查詢時間",
  questions_and_comments: "",
  questions_and_suggestions: "",
  quick_guide: "快速指南",
  quick_input: "",
  quick_report: "快速報告",
  quick_report_completed: "快速報告完成",
  quick_report_failed: "快速報告失敗",
  quit_alarm_snapshot: "退出報警拍照",
  quit_editing: "",
  quit_the_inspection_task: "退出巡檢任務",
  quit_timelapsed_image_capture: "退出定時拍照",
  radar: "雷達",
  radar_chart: "雷達圖",
  radar_malfunction: "",
  rail_robot: "",
  rainbow: "彩虹",
  rainbow_hc: "彩虹HC",
  random: "",
  range: "",
  rangefinder: "",
  rangefinding: "測距",
  rangefinding_for_p2: "",
  range_inner: "區間內",
  range_outer: "區間外",
  raythink: "燧石",
  rdgy: "黑紅",
  read: "讀取",
  reading_files: "讀取文件中…",
  ready: "",
  read_files: "讀取設備文件",
  read_status: "狀態讀取",
  realtime_alarm: "即時報警",
  real_name: "",
  real_name_cannot_be_empty: "",
  real_time: "即時監控",
  real_time_data: "實時數據",
  real_time_temp_curve: "即時溫度曲線",
  rear_radar: "",
  rear_radar_anomaly: "",
  rear_radar_information: "",
  reason: "原因",
  reauthorize: "重新授權",
  rebuild_cache: "",
  receiving_email: "接收郵箱",
  receiving_failed: "",
  recently_used_devices: "",
  recent_alarm_time: "最近報警時間",
  recent_trigger_time: "",
  recognition_distance: "",
  recognition_failed: "識別失敗",
  recognition_result: "",
  recognition_successful: "識別成功",
  recommended_size: "推薦大小",
  reconnect: "",
  reconnecting: "重連中",
  reconnect_failed: "重連失敗",
  record: "錄音",
  recording: "正在錄音",
  recordings: "",
  recording_directory: "錄影路徑",
  recording_failed: "錄製失敗",
  recording_file: "錄像文件",
  recording_file_duration: "錄影檔時長",
  recording_method: "記錄方式",
  recording_pause: "",
  recording_plan_deld_successfully: "錄影計畫刪除成功",
  recording_plan_deletion_failed: "錄影計畫刪除失敗",
  recording_plan_disabled_successfully: "關閉錄影計畫成功",
  recording_plan_enabled_successfully: "開啟錄影計畫成功",
  recording_plan_is_in_progress_cannot_be_deld: "錄影計畫正在執行，禁止刪除",
  recording_plan_time_conflicts_with_0: "錄像計劃設置時間與：{0}有沖突",
  recording_plan_update_failed: "錄影計畫更新失敗",
  recording_playback_ended: "錄影播放結束",
  recording_pls_try_again_later: "正在錄影，請稍好再試",
  recording_saved_successfully: "保存錄影成功",
  recording_save_failed: "保存錄影失敗",
  recording_source_platform: "錄影來源：平臺",
  recording_succeeded: "錄製完成",
  recording_type: "錄影格式",
  recording_video_save_and_exit: "",
  record_does_not_exist: "記錄不存在",
  record_from_d1_to_d2: "從 d1 開始錄影，到 d2 結束",
  record_status: "",
  record_the_min_storage_time: "",
  record_video: "錄影",
  rectangle: "矩形",
  recurring_task: "",
  red: "紅",
  reddish_brown: "紅棕",
  redhot: "紅熱",
  redis_server_exception: "redis伺服器異常",
  redownload: "重新下載",
  red_brick: "紅磚",
  red_shades: "漸變紅",
  reflected_temp: "反射溫度",
  reflected_temp_is_out_of_range: "反射溫度超出範圍",
  reflected_temp_is_required: "反射溫度不能為空",
  refresh: "刷新",
  refreshing: "",
  refreshing_list: "",
  refresh_alarm_subscription: "刷新報警訂閱",
  refresh_cloud_platform_ip: "",
  refresh_completed: "",
  refresh_device: "",
  refresh_failed: "刷新失敗",
  refresh_map: "",
  refresh_successful: "",
  refresh_the_list: "",
  refresh_user_permissions: "刷新用戶權限",
  refund: "",
  refunding: "",
  refund_and_service: "",
  refund_success: "",
  region: "區域",
  regional_statistics: "區域統計",
  region_config: "區域設置",
  region_io: "區域IO",
  region_linkage: "區域聯動",
  region_name: "區域名稱",
  region_number: "區域編號",
  region_number_reach_limit: "區域測溫數量達到上限",
  region_or_font_color: "區域&字體顏色",
  region_qty_less_than: "區域數不能超過",
  region_temp: "區域溫度",
  region_thermometry: "區域測溫",
  region_type: "區欄位型別",
  register: "去註冊",
  registered_password: "國標SIP設備註冊密碼",
  registration: "",
  regular_devices: "普通設備",
  reg_now: "",
  reissue: "",
  related_records: "關聯記錄",
  relative_time: "相對時間",
  relay: "繼電器",
  release_to_load: "",
  release_to_refresh: "",
  release_to_start_loading_data: "",
  relocation_completed: "重新定位完成",
  relocation_failed: "重新定位失敗",
  remaining_unexecuted_point_count: "",
  remaining_valid_duration: "剩餘有效時長",
  remarks: "備註說明",
  remarks_cannot_exceed_100_characters: "",
  remarks_should_not_exceed_100_characters: "",
  remember_information: "記住信息",
  reminder_for_driving_distance: "",
  reminder_for_front_vehicle_start: "",
  reminder_for_starting_distance: "",
  remind_me_later: "以後再說",
  remote_battery_capacity: "",
  remote_device: "遠程設備",
  remote_device_control_live_img_view: "",
  remote_files: "遠程檔",
  remote_gallery: "遠端圖庫",
  removal_successful: "",
  remove: "移除",
  remove_coriolis_effect: "",
  remove_robot: "",
  remove_target_failed: "剔除目標失敗",
  rename: "重命名",
  renting: "",
  repeated_alarm_count: "重復報警次數",
  repeated_alarm_n_times: "重複報警{n}次",
  repeat_count: "重復次數",
  repeat_event_alarm_interval: "重複業務報警間隔",
  report_designer: "報告編輯器",
  report_downloaded_successfully: "",
  report_download_failed: "",
  report_export_failed: "",
  report_generating: "",
  report_generation_time: "",
  report_has_been_downloaded: "",
  report_info: "報告資訊",
  report_loading: "",
  report_number: "",
  report_template_settings: "報告範本設置",
  report_title: "報告標題",
  report_to_center: "上報到中心",
  report_type: "報告類型",
  reposition: "重新定位",
  requesting: "請求中",
  request_canceled: "",
  request_error: "請求錯誤",
  reset: "重置",
  reset_alarm: "重置報警",
  reset_alarm_failed: "重置報警失敗。",
  reset_failed: "重置失敗",
  reset_password: "",
  reset_successful: "重置成功",
  reset_to_default_successful: "恢復默認成功",
  resolution: "分辨率",
  resolved: "已解決",
  resource: "資源",
  resource_id: "",
  resource_id_cannot_be_empty: "",
  resource_import_file_is_empty: "資源導入文件為空",
  resource_import_template_generation_failed: "資源導入範本生成失敗",
  resource_information_management: "資源資訊管理",
  resource_layer: "資源圖層",
  resource_management: "資源管理",
  resource_name: "資源名稱",
  resource_name_already_exists: "資源名稱已存在",
  resource_name_cannot_be_empty: "資源名稱不能為空",
  resource_name_only_allows_chinese_characters_numbers_english:
    "資源名稱僅允許輸入漢字、數位、英文、“-”、“_”",
  resource_name_required_name_must_be_unique: "資源名稱(必填，名稱不可重複)",
  resource_type: "資源類型",
  resource_type_cannot_be_empty: "資源類型不能為空",
  resource_type_name_only_allows_chinese_characters_numbers_englis:
    "資源類型名稱僅允許輸入漢字、數位、英文、“-”、“_”",
  resource_type_required: "資源類型(必填)",
  restart: "",
  restart_successful: "",
  restart_the_robot: "",
  restart_to_take_effect: "切換成功，重啟後生效",
  restore: "還原",
  restore_default: "恢復默認",
  restore_factory_settings: "恢復出廠設置",
  restore_task: "",
  results_are_being_synchronized: "",
  resume_execution: "",
  reticle: "",
  retry: "重試",
  retry_after_seconds: "",
  retry_after_x_seconds: "",
  retu: "返回",
  return_to_app: "",
  return_to_charging_pile: "",
  return_to_charging_point: "",
  return_to_charging_station: "",
  reverse_img: "",
  reverse_img_display: "",
  reverse_linkage: "反向聯動",
  review_order: "",
  review_route: "",
  revoke_authorization: "",
  re_search: "重新搜索",
  right: "右",
  right_hand_twist: "",
  right_side: "",
  right_side_device_status: "",
  ring_graph: "環狀圖",
  robot: "",
  robots_are_not_allowed_to_be_duplicated: "",
  robot_application_system: "",
  robot_battery_config: "",
  robot_control: "",
  robot_details: "",
  robot_hardware_failure_unable_to_continue_navigation: "",
  robot_has_reached_the_target_point: "",
  robot_inspection_config: "",
  robot_integration: "",
  robot_is_already_associated_with_an_organization_pls_unassociate: "",
  robot_is_in_auto_mode_confirm_to_switch_to_manual_mode: "",
  robot_is_moving_task_cannot_be_resumed: "",
  robot_is_moving_to_the_target_point_manual_control_is_not_possib: "",
  robot_is_offline: "",
  robot_list: "",
  robot_location_lost: "",
  robot_locked: "",
  robot_malfunction: "",
  robot_management: "",
  robot_management_cloud_platform: "",
  robot_model: "",
  robot_name: "",
  robot_name_cannot_be_empty: "",
  robot_network_exception_ope_failed: "",
  robot_not_bound: "",
  robot_not_bound_to_map: "",
  robot_offline: "",
  robot_operating_voltage: "",
  robot_point_inconsistent_with_platform: "",
  robot_started_moving_towards_target_point: "",
  robot_status: "",
  robot_storage_config: "",
  robot_successfully_switched_to_auto_mode: "",
  robot_successfully_switched_to_manual_mode: "",
  robot_system: "",
  robot_unable_to_reach_target_point: "",
  robot_unresponsive: "",
  roi_temp: "roi測溫",
  role: "角色",
  role_cannot_be_empty: "",
  role_data: "",
  role_id: "",
  role_information: "",
  role_management: "",
  role_name: "",
  role_name_cannot_be_empty: "",
  role_name_must_be_chinese_characters_or_letters_and_no_longer_th: "",
  role_name_must_be_letters_or_chinese_characters_and_no_longer_th: "",
  role_order: "",
  role_order_cannot_be_empty: "",
  role_settings: "角色設置",
  role_status: "",
  roof_materials: "屋頂材料",
  roof_of_the_car: "",
  rotate_90clockwise: "順時針旋轉90°",
  rotate_90counterclockwise: "逆時針旋轉90°",
  rotate_left: "左轉",
  rotate_right: "右轉",
  rotation_speed: "旋轉速度",
  route_vector_layer: "路線向量圖層",
  row: "",
  row_details: "",
  row_no: "",
  rubber_soft_and_hard: "橡膠(軟,硬質)",
  rule: "規則",
  rules_cannot_be_empty_and_there_must_be_at_least_one_enabled_rul:
    "規則不可為空，處於啟用狀態的規則不得少於一項。無法與規則匹配的報警，系統將認為其是誤報，不予提示。",
  rule_name: "規則名稱",
  rule_setting: "規則設置",
  rural_straw_burning: "農村秸稈",
  russian: "俄語",
  s: "秒",
  sailboat: "帆船",
  sale: "",
  sales_volume: "",
  sales_volume_priority: "",
  same_as_browser_time: "",
  same_as_current_location: "",
  same_as_env_weather: "",
  saturday: "週六",
  save: "保存",
  save_0_event_records: "保存0條事件記錄",
  save_and_generate_reports: "",
  save_as: "另存為",
  save_as_template: "保存為範本",
  save_curve: "保存曲線",
  save_directory: "保存路徑",
  save_directory_is_required: "保存路徑不能為空",
  save_failed: "保存失敗",
  save_file: "保存文件",
  save_image: "保存圖片",
  save_in_segment: "分段保存",
  save_password: "保存密碼",
  save_path_format_error: "保存路徑格式錯誤",
  save_path_starting_with_eg_mnt_record_storage:
    "保存路徑,以 / 開頭,如/mnt/record_storage",
  save_settings: "保存設置",
  save_settings_failed: "保存設置失敗",
  save_success: "保存成功",
  save_view: "保存視圖",
  scanning: "正在掃描",
  scan_qr_code: "",
  scan_tour: "掃描巡航",
  scan_to_download_app: "掃一掃下載APP",
  scene_mode: "場景模式",
  scheduled_reboot: "",
  scope: "",
  scope_calibration_unit: "",
  scope_height: "",
  scope_information: "",
  score: "",
  screenshot: "",
  screenshot_count: "",
  screen_display: "",
  screen_tilt: "",
  sd_card_detected_update: "檢測到SD卡,開始更新",
  sd_card_is_full: "Sd卡已滿",
  search: "搜索",
  searching: "搜索中",
  search_and_rescue_vessel: "搜救船",
  search_by_column_name: "",
  search_by_informant: "",
  search_by_robot_name: "",
  search_device: "搜索設備",
  search_failed: "搜索失敗。",
  search_for_bluetooth_devices: "查找藍牙設備",
  search_product: "",
  search_resource: "搜索素材",
  secondary_server_status: "從伺服器狀態",
  second_calibration: "二次標定",
  select: "選擇",
  selected: "已選中",
  select_all: "全選",
  select_color: "選擇顏色",
  select_directory: "選擇路徑",
  select_the_current_wifi_name: "",
  seled: "已選擇",
  selfie: "自拍",
  self_gps: "",
  self_positioning: "",
  self_positioning_failed: "",
  sel_alarm_item: "",
  sel_alarm_name: "選擇報警名稱",
  sel_alarm_source: "選擇報警源",
  sel_channel: "選擇通道",
  sel_coupon: "",
  sel_date: "選擇日期",
  sel_device: "選擇設備",
  sel_end_time: "選擇結束日期",
  sel_inspection_points: "",
  sel_inspection_point_or_enter_distance: "",
  sel_linkage_action: "選擇聯動動作",
  sel_notification_personnel: "選擇告知人員",
  sel_parent_department: "",
  sel_picture: "選擇圖片",
  sel_pseudo_color: "",
  sel_recording_time: "選擇錄影時間",
  sel_robot: "",
  sel_start_time: "選擇開始日期",
  sel_the_wifi_network_with_current_device_name_to_connect: "",
  sel_the_wifi_network_with_the_name_of_the_connecting_device:
    "根據連接設備選擇正確的Wifi網路",
  sel_time: "",
  sel_time_cannot_be_empty: "",
  sel_time_range: "",
  sel_user: "",
  sending: "",
  sending_failed: "",
  send_a_report: "",
  sensor: "",
  sensor_alarm: "感測器報警",
  sensor_device: "機芯設備",
  sensor_malfunction: "",
  sep: "九月",
  sequence: "輪巡",
  serial_number: "",
  series: "系列",
  server_access_timeout: "訪問服務器超時",
  server_address: "服務器地址",
  server_address_cannot_be_empty: "",
  server_alarm: "服務器報警",
  server_background: "",
  server_connection_failed: "連接伺服器失敗",
  server_ip_cant_be_empty: "服務器IP不能為空。",
  server_ip_invalid: "服務器IP無效。",
  server_offline: "服務器離線",
  server_port_cant_be_empty: "服務器端口不能為空。",
  server_recording_storage_settings: "伺服器錄影存儲設置",
  service_exception: "服務異常",
  service_request_timed_out: "服務請求超時",
  servo: "",
  servo_information: "",
  servo_malfunction: "",
  setting: "設置",
  settings_general_about_modify_name: "",
  settings_personal_hotspot_modify_settings_name_modify_password: "",
  settings_successful_settings_failed_devices:
    "設置成功：{0}，設置失敗：{1}，失敗設備：{2}",
  setting_failed: "設置失敗",
  setting_failed_pls_try_again: "",
  setting_in_process_pls_wait: "正在設置，請稍候",
  setting_success: "設置成功",
  settle: "",
  set_as_default: "",
  set_atmospheric_temp_failed: "設置環境溫度失敗",
  set_auto_tracking_succeeded: "設定自動跟隨成功",
  set_brightness_failed: "設置亮度失敗",
  set_color_palette_failed: "設置偽彩失敗",
  set_contrast_failed: "設置對比度失敗",
  set_dde_enabled_failed: "設置圖像增強使能失敗",
  set_dde_failed: "設置圖像增強失敗",
  set_distance_failed: "設置距離失敗",
  set_emissisivity_failed: "設置發射率失敗",
  set_filter_enabled_failed: "設置濾波使能失敗",
  set_gain_mode_failed: "設置增益模式失敗",
  set_image_flip_failed: "設置圖像翻轉失敗",
  set_manual_tracking_succeeded: "設定手動跟隨成功",
  set_measurement_range_failed: "設置測溫範圍失敗",
  set_mobile_wifi: "",
  set_osd_failed: "設置網板疊加狀態失敗",
  set_phone_number_in_user_settings: "在用戶設置中設置手機號",
  set_reflected_temp_failed: "設置反射溫度失敗",
  set_to_0: "",
  set_tracking_mode_failed: "設定跟隨模式失敗",
  set_tracking_status_failed: "設定跟隨狀態失敗",
  set_transmittance_failed: "設置透過率失敗",
  set_valid_environmental_parameters_failed: "設置環境參數生效失敗",
  set_valid_env_parameters_succeeded: "設定環境參數生效成功",
  share: "分享",
  shared_channels: "已共享通道",
  shared_channel_number: "共享通道數",
  share_by_qrcode: "二維碼分享",
  sheet_metal: "金屬片",
  shield: "區域遮罩",
  shielded_alarm: "屏蔽報警",
  shielded_area_config: "遮罩區域設置",
  shielded_area_name: "屏蔽區域圖層",
  shielded_area_sa: "屏蔽區域",
  shielding_distance_compensation: "",
  shield_area_layer: "屏蔽區域圖層",
  shield_duration: "屏蔽時長",
  shield_name: "屏蔽名稱",
  shield_range: "屏蔽範圍",
  shipping_address: "",
  shipping_cost: "",
  shipping_credits: "",
  ships_equipped_with_pollution_prevention_facilities_or_equipment:
    "安裝有防汙染設施或設備的船",
  shld_ar_mgmt: "屏蔽區域管理",
  shooting_device: "拍攝設備",
  shooting_time: "拍攝時間",
  should_bigger_than_0: "",
  should_the_area_near_this_location_be_set_as_a_shieled_area:
    "是否將該位置附近設置成屏蔽區域？",
  show_details: "顯示詳情",
  show_logo: "顯示Logo",
  show_only_malfunctioning_robots: "",
  show_video: "展示視頻",
  shutter: "快門",
  shutter_calibration_failed: "",
  shutter_calibration_succeeded: "",
  shutter_correction: "快門校正",
  shutter_correction_failed: "快門校正失敗",
  sick_chicken_analysis: "",
  side_alarm_bar_switch: "側邊報價欄開關",
  signal_light: "",
  silk: "絲綢",
  simplified_chinese: "簡體中文",
  single: "",
  single_frame_occurrence_confidence_threshold: "單幀/次可信閾值",
  single_rangefinding: "",
  single_task: "",
  sip_server_ip: "國標SIP伺服器IP",
  sip_server_number: "國標SIP伺服器編號",
  sip_server_number_should_be_20_characters_in_length:
    "國標SIP伺服器編號長度應為20",
  sip_server_port: "國標SIP伺服器端口",
  sip_service_ip: "SIP服務IP",
  sip_service_national_standard_code: "SIP服務國標編碼",
  sip_service_national_standard_domain: "SIP服務國標域",
  sip_service_port: "SIP服務端口",
  skin: "皮膚",
  skip_frames: "跳幀",
  sky: "天空",
  slam_radar: "",
  slam_radar_anomaly: "",
  slam_radar_information: "",
  slave_address: "從站地址",
  slave_address_range_2_254: "從站地址範圍2-254",
  sleep: "",
  slow: "慢放",
  slow_forward: "慢進",
  smart_image_capture_list: "智能拍攝列表",
  smart_import_will_automatically_create_single_ip_dual_channel_de:
    "智能導入將會自動創建單IP雙通道設備關聯關係、相似名稱的單通道設備的關聯關係，故在智能導入前，需設置系統內的設備名稱和通道名稱",
  smart_inspection_snapshot_is_disabled_under_visual_mode:
    "可見光模式暫不支持智能巡檢拍攝",
  smart_patrol: "智能巡檢",
  smart_patrol_tasks: "智能巡檢任務",
  smokefire_detection: "煙火檢測",
  smoke_detection: "煙霧檢測",
  smoke_recognition_algorithm_visible: "煙識別演算法(可見光)",
  smooth_black_paint: "平滑黑漆",
  sms: "短信",
  sms_login: "短信登錄",
  sms_platform: "短信平臺",
  sms_platform_account: "短信平臺帳號",
  sms_platform_password: "短信平臺密碼",
  sms_platform_settings: "短信平臺設置",
  sms_sent: "短信已發送",
  sms_signature: "短信簽名",
  sn: "",
  snapshot: "抓圖",
  snapshot_directory: "抓圖路徑",
  snapshot_failed: "抓圖失敗",
  snapshot_interval: "抓拍間隔時間",
  snapshot_limit_5_100: "抓拍張數限制5-100張",
  snapshot_resolution: "抓圖解析度",
  snapshot_success: "抓圖成功",
  snapshot_time_limit_5_100s: "抓拍時間限制5-100S",
  snapshot_type: "抓圖格式",
  sn_cannot_be_empty: "",
  software_license: "軟件許可證",
  software_license_and_services_agreement: "軟體許可及服務協議",
  software_upgrade: "軟件升級",
  software_ver: "",
  sold: "",
  solved: "",
  sorry_currently_no_data_available: "",
  sorry_this_feature_is_currently_occupied_by_the_computer_addres:
    "很抱歉，該功能已被{0}佔用，該電腦位址為:{1}，MAC地址為:{2}，其使用完畢後您方能使用",
  sort: "排序",
  source: "設備源",
  source_address_error: "源位址錯誤",
  so_that_we_can_contact_you: "",
  space_cleanup_threshold: "",
  spanish: "西班牙語",
  speaker: "",
  speaker_malfunction: "",
  special: "特殊",
  special1: "特殊1",
  special2: "特殊2",
  specified_time: "特定時間",
  speech_remarks: "語音備註",
  speed: "",
  speed_dome: "球機",
  speed_limit: "",
  speed_setting_failed: "",
  spot: "點測溫",
  spot_number_reach_limit: "點測溫數量達到上限",
  square_1_2_diagonal_length: "正方形，數字為1/2對角線長度",
  standby: "備用",
  start: "開始",
  start_a_new_order_after_settlement: "",
  start_date: "",
  start_date_required: "開始日期不能為空",
  start_date_should_be_earlier_than_end_date: "開始日期應早於結束日期",
  start_frame_less_than_end_frame: "起始幀必須小於結束幀",
  start_from_d1_to_d2_record_from_t1_to_t2_for_each_w:
    "從 d1開始到 d2 結束， 每 w 的 t1 到 t2 錄影",
  start_from_d_record_fromt1_to_t2_for_each_w_never_stop:
    "從 d 開始， 每 w 的 t1 到 t2 錄影，永不結束",
  start_inspection: "",
  start_locate: "",
  start_observing: "",
  start_recording: "開始錄影",
  start_recording_failed: "開始錄影失敗",
  start_recording_success: "開始錄影成功",
  start_smart_image_capture_auto_alarm_snapshot_paused:
    "智能拍攝開啓,報警自動拍照暫停",
  start_time: "開始時間",
  start_timed_image_capture: "開始定時拍照",
  start_time_required: "開始時間不能為空",
  start_time_should_be_earlier_than_end_time: "開始時間應早於結束時間",
  start_tour: "開始巡航",
  start_upgrade: "開始升級",
  start_video_recording: "開始錄製",
  start_zoom_speed: "",
  start_zoom_speed_should_be_higher_than_end_zoom_speed: "",
  statistical_cloud_map: "",
  statistical_planning: "",
  statistical_results: "",
  statistical_rules: "",
  statistics: "統計",
  statistics_type: "統計類型",
  stats_failed: "統計失敗。",
  status: "狀態",
  steady_on: "常亮",
  step_1_configure_mobile_hotspot: "",
  step_2_wait_for_the_device_to_connect: "",
  step_3_device_connection_successful: "",
  stone: "石頭",
  stop: "停止",
  stop_alarm: "停止報警",
  stop_audio: "停止音頻",
  stop_failed: "",
  stop_in_place: "",
  stop_moving_window: "停止移動視窗",
  stop_rangefinding: "",
  stop_record: "停止錄影",
  stop_recording: "停止錄製",
  stop_video_recording: "確定停止錄製",
  storage: "",
  storage_space_alarm: "",
  storage_space_alarm_threshold: "",
  storage_temperature_range: "",
  streaming: "碼流",
  streaming_failed: "",
  streaming_media_server_exception: "流媒體伺服器異常",
  streaming_media_server_ip: "流媒體伺服器IP",
  streaming_media_server_port: "流媒體伺服器埠",
  streaming_successful: "",
  stream_playback_failed: "播流失敗",
  stream_switch_failed: "切換碼流失敗",
  stream_switch_succeeded: "切換碼流成功",
  street_building_number_house_number: "",
  strong_aluminium_oxide: "強氧化鋁",
  stuck_chicken: "",
  stuck_chicken_alarm: "",
  stuck_chicken_analysis: "",
  submission_failed: "",
  submission_failed_pls_check_your_network_connection: "",
  submit: "",
  submitted: "提交成功",
  submit_and_continue: "",
  submit_order: "",
  subnet_mask: "子網掩碼",
  subscriber_does_not_exist: "訂閱人不存在",
  subscription_added_successfully: "添加訂閱成功",
  subscription_information_already_exists_pls_modify_the_existing_:
    "已有訂閱信息，請在原有基礎上修改",
  subscription_information_does_not_exist: "訂閱資訊不存在",
  sub_application: "從應用",
  sub_stream: "輔碼流",
  success: "成功",
  success_prompt: "成功提示",
  success_to_del_data_in_cloud: "從雲平臺刪除成功",
  suggestions_and_feedback: "",
  suggest_for_you: "為你推薦",
  sunday: "週日",
  superior_function: "上級功能",
  superior_organization: "上級組織",
  superior_platform_code: "上級平臺編碼",
  superior_platform_ip: "上級平臺IP",
  superior_platform_port: "上級平臺端口",
  superior_platform_status: "上級平臺狀態",
  superior_sip_service_ip: "上級SIP服務IP",
  superior_sip_service_national_standard_code: "上級SIP服務國標編碼",
  superior_sip_service_national_standard_domain: "上級SIP服務國標域",
  superior_sip_service_port: "上級SIP服務端口",
  super_admin_cannot_be_modified: "超級管理員不給予修改",
  super_resolution: "超解析度",
  super_resolution_off: "關閉超分",
  super_resolution_on: "開啟超分",
  sure_to_cancel_the_order: "",
  sure_to_close_the_order_and_settle: "",
  surface: "面",
  surplus: "剩餘",
  suspected_abnormal: "",
  suspected_chicken_opening_mouth_detected: "",
  suspected_dead_chickens_found_in_chicken_cage_x_x_layer_x: "",
  suspected_dead_chicken_detected: "",
  suspected_dirty_chicken_coop_detected: "",
  suspected_discovery: "",
  suspected_false_alarm: "疑似誤報",
  suspected_non_laying_chicken_detected: "",
  suspected_normal: "",
  suspected_presence: "",
  suspected_presence_of_x_chickens: "",
  suspected_trapped_chicken_detected: "",
  suspected_uneven_feed_line_detected: "",
  suspected_water_line_anomaly_detected: "",
  suspected_weak_chicken_detected: "",
  switching_device_network: "正在切換設備網路",
  switching_failed_current_status_unchanged: "切換失敗，當前狀態不變",
  switching_successful_current_mode_is_1_restart_to_take_effect:
    "切換成功,當前模式%1,重啟生效",
  switching_successful_in_high_gain_mode_now: "切換成功，當前狀態為高增益",
  switching_successful_in_low_gain_mode_now: "切換成功，當前狀態為低增益",
  switching_to_high_gain_mode_pls_wait: "即將切換為高增益，請耐心等待",
  switching_to_low_gain_mode_pls_wait: "即將切換為低增益，請耐心等待",
  switch_main_tream: "切換主碼流",
  switch_mode: "",
  switch_soon: "即將切換",
  switch_sub_stream: "切換子碼流",
  switch_successful: "",
  switch_target_failed: "切換目標失敗",
  switch_tracking: "切換追蹤",
  switch_view: "切換視圖",
  sync: "",
  synchronization_time_failed: "同步時間失敗",
  synchronization_time_succeeded: "同步時間成功",
  sync_phone_time_to_the_device: "",
  sync_playback: "同步回放",
  sync_points: "",
  sync_successful: "",
  sync_time: "同步時間",
  sync_to_platform: "",
  system: "系統",
  system_alarm_email_subject: "【系統通知】系統運行報警統計通知",
  system_alarm_statistics_sending_settings: "系統報警統計發送設置",
  system_config: "系統配置",
  system_error: "",
  system_functions: "",
  system_function_mode: "系統功能模式",
  system_information: "",
  system_is_playing_a_video_do_you_want_to_shut_down:
    "系統正在播放錄影，是否選擇關機?",
  system_is_recording_do_you_want_to_shut_down: "系統正在錄影，是否選擇關機?",
  system_logo: "",
  system_maintenance: "",
  system_management: "系統管理",
  system_name: "",
  system_name_cannot_exceed_10_characters: "",
  system_setting: "系統設置",
  system_time: "",
  system_ver_information: "",
  sys_dev_online_ratio: "系統設備在綫比例",
  s_resend: "",
  s_serial: "S系列",
  target_auto_excl: "目標自動剔除",
  target_azimuth_angle: "目標方位角度",
  target_distance: "目標距離",
  target_elevation_angle: "目標俯仰角度",
  target_gps: "",
  target_latitude_and_longitude: "目標經緯度",
  target_location: "目標位置",
  target_point: "目標點",
  target_point_latitude: "目標點緯度",
  target_point_longitude: "目標點經度",
  target_positioning: "",
  target_positioning_failed: "",
  target_tracking: "切換目標跟隨",
  target_traj_overlay: "目標軌跡疊加",
  target_type: "目標類型",
  tas: "測溫分析系統",
  task: "",
  task_can_be_issued: "",
  task_completion_rate: "",
  task_creation_time: "",
  task_details: "",
  task_distribution_failed_for_the_same_robot_recurring_tasks_and_: "",
  task_distribution_failed_only_one_recurring_task_can_be_issued_f: "",
  task_distribution_invalid_cyclic_tasks_and_scheduled_tasks_canno: "",
  task_distribution_invalid_cyclic_task_start_and_end_times_cannot: "",
  task_distribution_invalid_only_one_cyclic_task_can_be_issued_for: "",
  task_distribution_invalid_same_named_task_already_exists_for_the: "",
  task_distribution_invalid_scheduled_task_start_time_cannot_be_wi: "",
  task_end_time: "",
  task_execution: "",
  task_execution_frequency: "",
  task_execution_method: "",
  task_files_not_existed: "令牌錯誤,請檢查設備時間",
  task_file_format_error: "任務文件格式錯誤",
  task_in_progress: "",
  task_issuance: "",
  task_name: "任務名",
  task_name_already_exists_pls_modify_and_try_again: "",
  task_name_cannot_be_empty: "",
  task_name_must_be_letters_numbers_or_chinese_characters_and_no_l: "",
  task_name_validation_passed: "",
  task_progress: "",
  task_ready: "",
  task_start_time: "",
  task_start_time_cannot_be_empty: "",
  task_status: "",
  task_success_rate: "",
  task_template: "",
  task_template_cannot_be_empty: "",
  task_template_not_imported: "",
  task_template_not_seled_cannot_import: "",
  task_termination: "",
  task_termination_failure: "",
  task_type: "任務類型",
  taxpayer_identification_number: "",
  temp: "溫度",
  temperature_parameter_settings: "溫度參數設置",
  temperature_trend_display: "溫度趨勢顯示",
  temperature_video_recording_mode: "溫度視頻錄像模式",
  template_content: "範本內容",
  template_has_been_deld_pls_sel_again: "",
  template_name: "範本名稱",
  template_name_cannot_be_empty: "範本名稱不能為空",
  template_name_duplicate: "模版名稱重複",
  temp_alarm: "溫度報警",
  temp_and_humidity_sensor_abnormal: "",
  temp_calibration: "",
  temp_chart: "測溫溫度圖",
  temp_cloud_map: "",
  temp_collection: "溫度採集",
  temp_curve: "溫度曲線",
  temp_diff: "差值溫度",
  temp_difference: "溫差",
  temp_difference_absolute_value: "溫差絕對值",
  temp_difference_alarm: "溫差報警",
  temp_difference_equal_to: "溫度差值等於",
  temp_difference_greater_than: "溫度差值大於",
  temp_difference_less_than: "溫度差值小於",
  temp_error: "溫度誤差",
  temp_exceeds_limit: "溫度超標",
  temp_greater_than: "溫度大於",
  temp_icon_style: "",
  temp_information_display_mode: "溫度資訊顯示模式",
  temp_interval: "溫度區間",
  temp_less_than: "溫度小於",
  temp_level_threshold_is_required: "溫度級別閾值不能為空",
  temp_lower_limit_over_floating: "溫度下限值超浮",
  temp_meas: "測溫",
  temp_measurement_analysis_report: "測溫分析報告",
  temp_measurement_enabled_successfully: "開啟測溫成功",
  temp_measurement_enablement_failed: "開啟測溫失敗",
  temp_measurement_gear: "測溫檔位",
  temp_measurement_rule_name: "測溫規則名稱",
  temp_meas_rule: "測溫規則",
  temp_range: "溫寬拉伸範圍",
  temp_range_setting: "溫寬拉伸範圍設置",
  temp_record: "測溫記錄",
  temp_rise: "溫升溫度",
  temp_rise_alarm: "溫升報警",
  temp_rise_alarm_rise_by_t_every_s1_seconds_lasting_for_s2_secon:
    "溫升報警(每{s1}秒升高{t}℃，持續{s2}秒)",
  temp_rise_alarm_rise_by_t_every_s_seconds_for_n_times:
    "溫升報警(每{s}秒升高{t}℃，持續{n}次)",
  temp_rise_level_threshold_is_required: "溫升級別閾值不能為空",
  temp_rise_threshold_is_required: "溫升閾值不能為空",
  temp_rise_time_interval: "溫升時間間隔",
  temp_sensor_status: "",
  temp_slope: "溫度斜率",
  temp_slope_equal_to: "溫度斜率等於",
  temp_slope_greater_than: "溫度斜率大於",
  temp_slope_less_than: "溫度斜率小於",
  temp_statistics: "測溫統計",
  temp_threshold_is_required: "溫度閾值不能為空",
  temp_unit: "溫度單位",
  temp_upper_limit_over_floating: "溫度上限值超浮",
  temp_video_is_cannot_displayed_on_the_device: "溫度視頻不支持設備端播放",
  "temp℃": "",
  tenant_id_cannot_be_empty: "",
  ten_minutes: "10分鐘",
  terminate: "",
  terminated_successfully: "",
  terminate_again: "",
  testing_environment: "測試環境",
  test_alarm: "模擬報警",
  test_reports: "測試報告",
  text_remarks: "文字備註",
  text_setting: "文本設置",
  tgt_dist_m: "目標距離(m)",
  thank_you_for_your_participation: "",
  there_are_bound_users_under_this_role: "",
  there_are_no_bound_users_under_this_role: "",
  there_are_no_channels_being_playback: "沒有正在播放的頻道",
  there_are_no_channels_being_previewed: "沒有正在預覽的通道",
  there_are_still_count_points_not_inspected: "",
  there_are_still_unprocessed_alarms_are_you_sure_you_want_to_leav:
    "還存在未處理的報警，確定不處理就離開嗎？",
  there_are_users_bound_to_this_role_pls_unbind_all_users_before_d: "",
  there_can_be_no_cross_overlapping_isothermal_temperature_ranges:
    "等溫帶溫度範圍不能有交叉重疊",
  there_is_already_a_loop_task_on_the_device: "",
  there_is_an_unfinished_video_export_task_pls_try_again_later:
    "當前有尚未完成的視頻導出任務，請稍後再試",
  there_is_a_file_with_the_same_name_in_the_current_path: "當前路徑下有同名檔",
  there_must_be_at_least_one_active_rule: "處於啟用狀態的規則不得少於一項",
  thermal: "單熱圖",
  thermal_camera: "",
  thermal_camera_information: "",
  thermal_camera_ver: "",
  thermal_fire: "熱成像-火點",
  thermal_fire_detection: "熱成像火點檢測",
  thermal_fire_spreading: "熱成像-火勢變大",
  thermal_imaging_mode: "熱成像模式",
  thermal_imgs: "熱成像圖",
  thermal_parameters: "紅外參數",
  thermal_screenshot: "",
  thermal_x1_visual_x1: "單熱圖單可見光",
  thermo_center: "測溫中心",
  thermo_report: "測溫報告",
  thermo_report_template: "測溫報告範本",
  the_affiliated_map_cannot_be_empty: "",
  the_affiliated_robot_cannot_be_empty: "",
  the_allowed_input_distance: "",
  the_allowed_input_emissivity_is: "",
  the_allowed_input_env_temp_is: "",
  the_allowed_input_humidity_is: "",
  the_allowed_reflected_temp: "",
  the_app_needs_to_use_your_local_network_to_send_the_broadcast:
    "App需要使用你的本地網路來發送廣播",
  the_associated_inspection_task: "",
  the_bad_pixel_is_being_saved: "",
  the_blackhot_is_disabled_under_isotherm_mode: "等溫線功能下黑熱色板不可用",
  the_charging_point_cannot_be_empty: "",
  the_column_number_should_be_a_positive_integer: "",
  the_current_device_name_is_unable_to_capture_image: "當前設備名過長,無法拍攝",
  the_current_directory_contains_submenus_pls_del_the_submenus_fir:
    "當前目錄含有子菜單, 請先刪除子菜單",
  the_current_network_is_not_available_pls_connect_to_the_internet:
    "當前網路不可用，請將網路連接至互聯網",
  the_current_ope_will_modify_the_existing_recording_schedule_time:
    "當前操作會使原有錄影計畫時間修改，將停止原有錄影計畫，按新時間計畫執行, 是否繼續?",
  the_current_robot_is_in_auto_mode_and_cannot_be_controlled: "",
  the_current_software_ver_is: "",
  the_current_video_is_not_playing_so_recording_is_not_possible: "",
  the_current_video_is_not_playing_unable_to_capture_img: "",
  the_data_volume_is_too_large_and_the_remaining_alarm_records_can:
    "數據量過多，剩餘報警記錄無法繼續導出",
  the_device_already_exists: "設備已存在",
  the_device_discovered_an_emergency_in_the_direction_direction_at:
    "設備在{direction}方向{distance}處({villageName})發現警情。",
  the_device_does_not_currently_support_this_functionality:
    "設備暫不支援此功能",
  the_device_information_will_be_removed_after_factory_reset:
    "恢復出廠後設備資訊會清空",
  the_device_is_currently_in_continuous_rangefinding_do_you_want_t: "",
  the_device_is_disabled: "",
  the_device_is_upgrading_exiting_now_may_cause_the_upgrade_to_fai:
    "設備正在升級，當前退出可能導致設備升級失敗",
  the_device_name_only_supports_chinese_and_english_numbers_dots_h:
    "設備別名僅支援中英文、數位、點、橫杠、下劃線",
  the_device_will_restart_shortly_pls_reconnect_to_the_device_late:
    "設備即將重啟，稍後請重新連接設備",
  the_end_time_must_be_later_than_the_start_time: "",
  the_horizontal_axis_must_increase_sequentially: "水准座標必須依此增大",
  the_identifier_prefix_for_common_channel_0_does_not_match_the_de:
    "普通通道{0}的標識首碼與設備配置不一致，請檢查",
  the_identifier_prefix_for_eos_channel_0_does_not_match_the_devic:
    "周掃通道{0}的標識首碼與設備配置不一致，請檢查",
  the_image_has_already_been_captured: "該圖片已拍攝,是否重新拍攝",
  the_information_of_the_cage_layer_is_incomplete: "",
  the_inspection_task_is_in_progress_pls_end_first: "巡檢任務正在進行,請先結束",
  the_last_device_in_the_list_has_already_been_captured:
    "列表最後一個設備已拍攝完成",
  the_linked_channel_does_not_exist_in_the_system: "系統中不存在該聯動通道",
  the_linked_device_does_not_exist_in_the_system: "系統中不存在該聯動設備",
  the_max_env_temp_is_set_as: "",
  the_max_reflected_temp_is_set_as: "",
  the_min_env_temp_is_set_as: "",
  the_min_illumination_of_visible_light: "",
  the_min_reflected_temp_is_set_as: "",
  the_mobile_number_has_been_registered: "",
  the_network_communication_is_abnormal_and_the_n1_inspection_task: "",
  the_next_day: "",
  the_number_of_digits_for_the_account_must_be_20_and_only_numbers: "",
  the_number_of_triggers_for_intelligent_analysis_is_too_low:
    "觸發智能研判次數過低",
  the_organization_name_is_a_combination_of_letters_numbers_or_chi: "",
  the_password_does_not_meet_the_requirements: "",
  the_password_length_is_8_16_characters: "密碼長度為8~16",
  the_password_must_be_8_20_characters_long_and_include_both_numbe: "",
  the_password_should_be_5_20_characters: "密碼5~20位元字元",
  the_past_month: "",
  the_past_three_months: "",
  the_phone_is_connected_to_the_same_wi_fi_as_the_device:
    "手機與設備連接至同一Wi-Fi",
  the_phone_number_is_not_linked_to_any_account: "",
  the_preview_screen_shows_the_temperature: "預覽畫面顯示溫度",
  the_pwd_should_be_more_than_6_chars: "",
  the_pwd_should_be_more_than_8_chars: "密碼長度需大於8",
  the_query_time_span_is_12_hour: "可查詢時間跨度為12小時",
  the_query_time_span_is_1_hour: "可查詢時間跨度為1小時",
  the_query_time_span_is_24_hour: "可查詢時間跨度為24小時",
  the_range_maximum_value_needs_to_be_bigger_than_the_max:
    "注意：溫寬拉伸範圍最高值應大於最高溫",
  the_range_minimum_value_needs_to_be_less_than_the_min:
    "注意：溫寬拉伸範圍最低值應小於最低溫",
  the_range_minimum_value_needs_to_be_less_than_the_range_maximum:
    "注意：溫寬拉伸範圍最低值應小於最高值",
  the_recorded_file_has_reached_2gb_limit_pls_stop_recording:
    "錄影檔已達2GB，請手動停止錄影",
  the_recorded_file_has_reached_5gb_limit_pls_stop_recording:
    "錄影檔已達5GB，請手動停止錄影",
  the_report_is_being_exported_pls_view_it_under_the_specified_pat:
    "報表正在導出，請到該路徑下查看",
  the_robot_is_already_bound_to_the_chicken_coop_pls_choose_again: "",
  the_robot_is_in_an_unlocked_state_are_you_sure_you_want_to_switc: "",
  the_robot_is_in_auto_mode_are_you_sure_you_want_to_switch_to_man: "",
  the_robot_is_in_a_locked_state_are_you_sure_you_want_to_switch_t: "",
  the_rule_cannot_be_empty_and_cannot_continue_to_be_deld:
    "規則不可為空，不可繼續刪除",
  the_same: "同上",
  the_same_channel_cannot_have_multiple_associated_groups:
    "同一通道不能有多個關聯組",
  the_selected_quantity_is: "已選擇數量",
  the_server_is_having_a_hiccup_pls_try_again_later:
    "服務器開小差了，請稍後再試",
  the_slave_address_cannot_be_empty: "從站地址不能為空",
  the_specified_gb_standard_device_cannot_be_found_pls_check_if_th:
    "查詢不到指定的國標設備，請檢查設備是否離線",
  the_system_does_not_support_this_device: "",
  the_system_is_initializing: "系統正在初始化",
  the_system_license_has_expired: "系統許可已到期",
  the_system_license_is_about_to_expire: "系統許可即將到期",
  the_target_has_left_the_alert_area_and_cannot_be_tracked:
    "目標已離開警戒區，無法追蹤",
  the_template_name_already_exists: "模板名稱已存在",
  the_template_name_or_content_cannot_be_empty: "模板名稱或內容不能為空",
  the_template_name_should_consist_of_letters_numbers_or_chinese_c: "",
  the_time_span_is_longer_than_2_hours: "時間跨度超過2小時",
  the_time_span_is_longer_than_one_day: "時間跨度超過一天",
  the_trigger_channel_does_not_exist_in_the_system: "系統中不存在該觸發通道",
  the_trigger_device_does_not_exist_in_the_system: "系統中不存在該觸發設備",
  the_username_only_supports_chinese_and_english_numbers_dots_hori:
    "用戶名僅支援英文、數字、點、橫杠、下劃線",
  the_user_does_not_have_video_playback_permission_for_this_device:
    "該用戶沒有該設備錄像回放權限",
  the_user_has_the_permission_to_record_and_replay_videos_on_the_device:
    "該用戶有該設備錄像回放權限",
  the_user_is_currently_unauthorized: "該用戶當前無授權",
  the_video_is_currently_being_exported_mp4_after_deletion_the_exp:
    "當前該視頻正在導出mp4，刪除後將自動取消導出任務",
  the_view_of_the_linkage_ipc_is_beyond_the_panoramic_field_of_vie:
    "聯動IPC所視超出全景視場，無法反向聯動",
  the_whitehot_is_disabled_under_isotherm_mode: "等溫線功能下白熱色板不可用",
  the_wifi_name_does_not_meet_the_requirements: "",
  the_wifi_name_length_is_1_32_characters: "WiFi名稱長度為1~32",
  third_party_service_exception: "三方服務異常",
  this_bullet_cannot_be_deld: "",
  this_channel_is_already_favorited: "該通道已經被收藏",
  this_channel_of_the_device_is_offline: "該設備此通道已離線",
  this_device_channel_has_been_deld: "該設備通道已刪除",
  this_device_channel_is_offline: "該設備此通道已離線",
  this_function_can_only_be_enabled: "",
  this_is_already_the_first_alarm: "",
  this_is_already_the_last_alarm: "",
  this_is_a_piece_of_content: "",
  this_location_is_within_a_surveillance_blind_spot: "該位置為監控盲區",
  this_node_does_not_exist: "該節點不存在",
  this_organization_has_sub_organizations_cannot_be_deld:
    "該組織下有子組織，無法刪除",
  this_organization_is_already_associated_with_a_face_database_can:
    "該組織已經關聯人臉庫，無法刪除",
  this_organization_is_already_associated_with_users_cannot_be_del:
    "該組織已經關聯使用者，無法刪除",
  this_organization_is_associated_with_devices_cannot_be_deld:
    "該組織已關聯設備，無法刪除",
  this_phone_number_is_already_in_use: "該手機號已經被使用",
  this_protocol_is_not_currently_supported: "暫不支援此協定",
  this_record: "本記錄",
  this_robot_has_no_subordinate_channels_video_playback_is_not_pos: "",
  this_role_is_bound_to_users_cannot_be_deld: "該角色已綁定用戶，無法刪除",
  this_role_name_already_exists: "該角色名稱已經存在",
  this_user_does_not_have_permi_to_capture_device_imgs:
    "該使用者沒有設備抓圖許可權",
  this_user_does_not_have_permi_to_take_snapshots: "該用戶沒有設備抓圖許可權",
  this_user_does_not_have_ptz_control_permi_to_stop_this_device:
    "該使用者沒有雲台控制許可權停止此設備",
  this_user_has_no_operable_devices: "該使用者沒有可操作的設備",
  this_user_has_no_permi_to_download_device_recordings:
    "該使用者沒有該設備錄影下載許可權",
  this_user_has_no_permi_to_play_this_device: "該使用者沒有許可權播放此設備",
  this_user_has_no_subscription_information: "該使用者沒有訂閱資訊",
  this_user_has_permi_to_download_device_recordings:
    "該使用者有該設備錄影下載許可權",
  this_video_is_currently_being_exported_mp4_do_you_want_to_re_exp:
    "該視頻當前正在導出mp4，是否重新導出",
  this_video_server_is_associated_with_devices_pls_remove_the_asso:
    "該視訊伺服器已關聯設備，請解除關聯後再刪除",
  three_primary_colors: "",
  three_times_or_more: "",
  threshold: "閾值",
  threshold_for_repeated_alarm_times: "重複報警次數閾值",
  threshold_for_repeated_alarm_times_cannot_be_empty:
    "重複報警次數閾值不能為空",
  threshold_range_must_be_greater_than_0: "閾值範圍需大於0",
  threshold_range_must_be_less_than_or_equal_to_1: "閾值範圍需小於等於1",
  threshold_switch: "阈值開關",
  thumbnail: "縮略圖",
  thursday: "週四",
  tilt_lock_pitch_lock: "俯仰鎖定",
  time: "時間",
  timed_tasks: "定時任務",
  timeline_format: "時間軸格式",
  timer_photo: "定時拍照",
  times: "",
  time_calibration_config: "",
  time_calibration_interval: "",
  time_calibration_method: "",
  time_cost: "",
  time_interval_should_not_be_less_than_5s: "時間間隔不小於5s。",
  time_of_payment: "",
  time_price: "",
  time_span_cannot_exceed_24h: "時間跨度不能超過24h。",
  time_span_cannot_exceed_2h: "時間跨度不能超過2小時。",
  time_span_cannot_exceed_3_days: "時間跨度不能超過3天。",
  time_span_cannot_exceed_3_months: "時間跨度不能超過3個月。",
  time_span_cannot_exceed_5_min: "時間跨度不能超過5分鐘。",
  time_span_cannot_exceed_6_months: "時間跨度不能超過6個月。",
  time_sync: "",
  time_synchronization: "時間同步",
  time_synchronization_interval_cannot_be_empty: "",
  time_synchronization_interval_must_be_numeric: "",
  time_sync_setting: "",
  title: "",
  to: "——",
  today: "今天",
  todays_alarmed_points: "",
  todays_inspected_points: "",
  token_auth_failed: "token認證失敗",
  token_error_pls_check_device_time: "令牌錯誤,請檢查設備時間",
  tolerance_temp: "容差溫度",
  too_many_drawing_points_pls_redraw: "繪製點數過多，請重新繪製",
  top_left: "左上",
  top_level_menu: "頂級菜單",
  top_right: "右上",
  total: "總數",
  totally_rusted_cast_iron: "完全生鏽鑄鐵",
  totally_rusted_iron_plate: "完全生鏽鐵板",
  totally_rusted_roll_iron_plate: "完全生鏽軋鐵板",
  totally_rusted_steel_oxide: "完全生鏽氧化鋼",
  total_entries: "",
  total_frames: "幀數",
  total_height: "",
  total_inspection_tasks: "",
  total_inventory: "",
  total_number_of_ai_recognition_imgs_since_the_start_of_img_captu:
    "從開始截取圖像後，總計截取的AI識別圖像總量",
  total_number_of_columns: "",
  total_number_of_dead_chickens: "",
  total_number_of_frames_for_ai_recognition_extraction: "AI識別取幀總量",
  total_number_of_pigsties: "",
  total_weight: "",
  total_weight_of_column: "",
  tour: "巡航",
  towboat: "拖輪",
  to_achieve_automatic_ptz_tracking_trajectory_recognition_in_the_:
    "為達到雲臺自動跟蹤目標效果，需開啟檢測區域的軌跡識別。",
  to_adjust_the_ambient_temp_ensure_that_the_atmos_transmittance_i:
    "調整環境溫度，需保證大氣透過率小於1，請調整大氣透過率",
  to_adjust_the_reflection_temp_ensure_that_the_emissivity_is_less:
    "調整反射溫度，需保證發射率小於1，請調整發射率",
  to_settle: "",
  tracking_status: "跟隨狀態",
  traditional_chinese: "繁體中文",
  trajectory_settings: "彈道設置",
  transfer_failed: "传输失败",
  transfer_firmware: "传输固件",
  transmission_mode: "傳輸模式",
  transmittance: "透過率",
  transmittance_is_out_of_range: "透過率超出範圍",
  transmittance_is_required: "透過率不能為空",
  tripwire_intrusion: "絆線入侵",
  tropical: "",
  true_east: "正東",
  true_heading_of_vessel: "船艏真航向",
  true_north: "正北",
  true_south: "正南",
  true_west: "正西",
  tuesday: "週二",
  tugboat: "拖船",
  turkish: "土耳其語",
  turning_on_location_switch_required: "",
  turn_off_io_time: "(自動關閉報警)過濾時間",
  turn_on_message_notification_to_receive_device_information_in_ti: "",
  twenty_minutes: "20分鐘",
  twice: "",
  twist_rate: "",
  two_point_rangefinding: "",
  type: "類型",
  typec_usb_interface: "",
  t_serial: "T系列",
  ultrasonic: "",
  ultrasonic_anomaly: "",
  unable_to_add_the_device_pls_install_the_certificate:
    "設備無法添加，請安裝證書",
  unable_to_add_the_device_the_certificate_has_expired_pls_contac:
    "設備無法添加，證書已經過期；請聯系管理員進行授權",
  unable_to_add_the_device_the_number_of_channels_exceeds_the_auth:
    "設備無法添加，通道數超過授權數量;請聯系管理員進行授權",
  unable_to_del_while_downloading: "",
  unable_to_get_channel_information: "無法獲取通道資訊",
  unable_to_get_device_information: "無法獲取設備資訊",
  unable_to_get_device_information_pls_confirm_if_the_device_is_co:
    "無法獲取設備資訊，請確認是否已連接設備",
  unable_to_locate_the_fire_point: "未能定位火點",
  unable_to_read_file_format: "無法讀取文件格式",
  unable_to_recognize_vessel_type: "無法識別船只類型",
  unable_to_record_temporarily: "",
  unanalyzable_file: "此檔不能分析",
  unassigned: "",
  unassociated: "",
  unauthorized: "",
  unbind: "解綁",
  unbind_user: "解綁用戶",
  unbound: "未綁定",
  unbound_successfully: "解綁成功",
  uncertificated: "",
  unchangeable_during_linkage_recording: "有通道聯動錄影中，不可修改",
  unconfirmed: "",
  unconnected_device: "設備未連接",
  undeletable: "不能刪除",
  undeletable_during_linkage_recording: "有通道聯動錄影中，不可刪除",
  uneven_feed_line_alarm: "",
  unfavorite: "取消收藏",
  unfinished_download_tasks_will_be_cleared_after_exiting_are_you_:
    "退出後未完成的下載任務將清空，確定退出嗎？",
  unfinished_download_tasks_will_be_cleared_after_logout_are_you_s:
    "退出後未完成的下載任務將清空，確定註銷嗎？",
  unfold: "展開",
  unilateral_inspection: "",
  uninspected_points: "",
  unit: "單位",
  units: "",
  unit_settings: "單位設置",
  unknown: "未知",
  unknown_directory: "路徑不存在",
  unknown_exception: "",
  unknown_folder: "檔夾不存在",
  unknown_img: "",
  unknown_ope: "未知操作",
  unknown_points_need_synchronization: "",
  unknown_username_or_incorrect_pwd: "用戶名不存在或密碼錯誤",
  unlock: "解鎖",
  unlocked: "",
  unlock_failed: "解鎖失敗",
  unlock_succeeded: "解鎖成功",
  unlock_the_robot: "",
  unpaid: "",
  unprocessed: "未處理",
  unrecoverable_deletion: "",
  unsale: "",
  unseled: "未選擇",
  unsel_all: "取消全選",
  up: "上",
  update: "更新升級",
  updated_inspection_point_successfully: "",
  update_and_import: "",
  update_complete: "更新完成",
  update_date: "",
  update_failed: "",
  update_failed_check_code_error: "",
  update_files: "",
  update_file_not_detected: "未檢測到更新檔案",
  update_firmware: "更新固件",
  update_from_sd_card: "從sd卡更新",
  update_information: "",
  update_location: "",
  update_palette: "更新色板",
  update_starup_picture: "",
  update_succeeded_auto_power_off_after_1_minute: "",
  update_success_pls_restart: "更新成功，請重啟設備",
  update_time: "",
  updating_patrol_plan_succeeded: "更新輪巡計畫成功",
  upgrade: "",
  upgrade_completed: "",
  upgrade_completed_rebooting: "",
  upgrade_failed: "升級失敗",
  upgrade_failed_due_to_device_network_issue: "升級失敗，設備網路異常",
  upgrade_failed_pls_exit_and_try_again: "",
  upgrade_now: "立即升級",
  upgrade_package_download_failed: "升級包下載失敗",
  upgrade_package_download_successful: "升級包下載成功",
  upgrade_package_error: "升級包錯誤",
  upgrade_package_upload_failed: "升級包上傳失敗",
  upgrade_package_upload_successful: "升級包上傳成功",
  upgrade_preparation: "升級準備",
  upgrade_reminder: "升级提醒",
  upgrade_successful: "升級成功",
  upload: "上傳",
  uploaded_file_exceeds_the_limit: "上傳文件已超過限製",
  uploaded_file_has_exceeded_limits: "上傳檔已超過限制",
  uploaded_img_size_exceeds: "上傳圖片大小超過",
  uploaded_logo_size_cannot_exceed_500kb: "",
  uploading: "正在上傳",
  upload_error: "上傳錯誤",
  upload_failed: "上傳失敗",
  upload_finish: "上傳完成",
  upload_log: "",
  upload_success: "上傳成功",
  upload_the_upgrade_package_to_the_device: "上傳升級包至設備",
  upper_temp_limit_should_be_greater_than_lower_temp_limit:
    "溫度上限應大於溫度下限",
  upper_threshold: "閾值上限",
  up_down_flip: "上下翻轉",
  up_to_16_channels_can_be_seled: "最多可選16個通道",
  urban_fire: "城市火災",
  usb_camera: "USB相機",
  usb_disk: "U盤",
  usb_mode: "USB模式",
  usb_to_serial_port: "USB轉串口",
  used_to_receive_alert_messages: "用於接收告警短信",
  user: "",
  username: "用戶名",
  username_must_be_letters_numbers_or_chinese_characters_and_no_lo: "",
  username_must_be_letters_or_numbers_and_no_longer_than_20_charac: "",
  username_only_supports_english_numbers_period_hyphen_underscore:
    "用戶名僅支援英文、數字、@、點、橫杠、底線、反斜杠",
  username_or_pwd_error: "用戶名或密碼錯誤",
  username_required: "用戶名(必填)",
  users_full_name: "",
  user_agreement: "用戶協議",
  user_bound_to_app: "已綁定app用戶",
  user_cannot_be_queried: "無法查詢到用戶",
  user_defined_frame: "自定義幀頻",
  user_does_not_exist: "用戶不存在",
  user_email: "",
  user_entity_corresponding_field: "",
  user_exist: "",
  user_id: "",
  user_locked: "用戶已鎖定",
  user_management: "",
  user_manual: "用戶手冊",
  user_name: "用戶名",
  user_name_cannot_be_empty: "",
  user_name_is_required: "用戶名不能為空",
  user_name_must_be_letters_or_chinese_characters_and_no_longer_th: "",
  user_name_or_name: "用戶名或姓名",
  user_nickname: "",
  user_nickname_cannot_be_empty: "",
  user_privacy_policy: "",
  user_remarks: "",
  user_remarks_cannot_exceed_100_characters: "",
  user_role: "用戶角色",
  user_settings: "用戶設置",
  user_table_corresponding_field: "",
  val: "",
  valid_after_software_restart: "軟體重啟後生效",
  valid_calibration_failed: "標定生效失敗",
  valid_calibration_succeeded: "標定生效成功",
  vehicle: "車",
  vehicle_alarm: "",
  vehicle_excavator_recognition_algorithm_thermal:
    "車輛、挖掘機識別演算法(熱成像)",
  vehicle_patrol: "車巡",
  ver: "版本",
  verification_code: "驗證碼",
  verification_code_format_error: "",
  verification_code_generation_service_error: "驗證碼生成服務異常",
  verification_code_not_existed_or_expired: "驗證碼不存在或已過期",
  verification_code_sending_failed: "驗證碼發送失敗",
  verification_code_sent_successfully: "驗證碼發送成功",
  verification_code_should_be_6_digits: "",
  version: "版本號",
  vertical: "",
  vertical_angle: "",
  vertical_click_value: "",
  vertical_up_down: "",
  ver_check_failed: "版本檢測失敗",
  ver_cur: "當前版本",
  ver_upd: "版本更新",
  vessel: "船",
  vessel_coordinates: "船隻座標",
  vessel_destination: "船隻目的地",
  vessel_latitude_and_longitude: "船隻經緯度",
  vessel_name: "船隻名稱",
  vessel_speed_in_knots: "船隻速度（節）",
  vessel_type: "船隻類型",
  ves_speed_knots: "船隻速度(節)",
  video: "視頻",
  video_alarm: "視頻報警",
  video_analysis: "視頻分析",
  video_anomaly_recording_failed: "視頻未播放，無法錄製",
  video_application: "視頻應用",
  video_blocked: "視頻遮擋",
  video_cannot_be_played: "視頻無法播放",
  video_download: "錄影下載",
  video_download_failed: "",
  video_inspection: "",
  video_interval: "錄影間隔",
  video_larger_than_500m_is_unabled_to_be_uploaded: "無法上傳大於500M  ",
  video_lost: "視頻丟失",
  video_merging_in_progress_pls_wait: "視頻合併生成中，請稍後",
  video_playback: "錄影重播",
  video_playback_linkage_snapshot: "錄影重播&聯動抓圖",
  video_query_failed: "查詢錄像失敗。",
  video_recorded_successfully_pls_check_in_the_phone_gallery: "",
  video_recording: "錄影中",
  video_replay: "",
  video_saving: "",
  video_server: "視訊伺服器",
  video_server_already_exists: "視訊伺服器已存在",
  video_settings: "錄像設置",
  video_surveillance_alarmvid_sur_alm: "視頻監控報警",
  video_transcoding: "視頻轉碼中",
  video_transcoding_succeeded: "視頻轉碼成功",
  video_wall: "電視牆",
  view: "視圖",
  viewtrack: "查看並追蹤",
  view_and_manage_the_imgs_videos_in_the_device: "",
  view_cage_positions: "",
  view_details: "查看詳情",
  view_device_alarms: "設備報警查看",
  view_event_alarms: "業務報警查看",
  view_id: "視圖ID",
  view_img: "",
  view_information: "",
  view_inspection_results: "",
  view_logistics: "",
  view_map: "",
  view_mode: "圖像模式",
  view_more: "",
  view_name: "視圖名稱",
  view_pen: "",
  view_report: "",
  view_task_queue: "",
  view_the_report: "",
  view_video: "查看視頻",
  vip: "",
  visible: "可見光",
  visible_fire: "可見光-火",
  visible_fire_detection: "可見光-火檢測",
  visible_light_malfunction: "",
  visible_mode: "可見光模式",
  visible_mode_no_measurement_set: "可見光模式下不支持測量設置",
  visible_mode_no_palette_set: "可見光模式下不支持偽彩設置",
  visible_mode_no_params_set: "可見光下不支持參數設置",
  visible_smoke: "可見光-煙",
  visible_smoke_detection: "可見光-煙檢測",
  visible_smoke_detection_visible_fire_detection:
    "可見光-煙檢測與可見光-火檢測",
  visible_smoke_visible_fire: "可見光-煙與可見光-火",
  visual_imgs: "",
  visual_screenshot: "",
  visual_settings: "",
  visual_smokefire_detection: "可見光煙火檢測",
  visual_snapshot: "",
  vis_3000_player_format: "VIS-3000 Player格式",
  voice_announcement: "語音播報",
  voltage: "電壓",
  volume: "",
  waiting: "等待中",
  waiting_for_download: "",
  wait_apply: "",
  wait_pay: "",
  wait_receive: "",
  warning: "警告",
  warning_blue: "警示藍",
  warning_green: "警示綠",
  warning_prompt: "警告提示",
  warning_red: "警示紅",
  warranty: "",
  water: "水",
  waterline: "",
  waterline_recognition: "",
  watermark: "",
  water_line_alarm: "",
  wavelength: "",
  weak_chicken_alarm: "",
  weak_gps_signal: "",
  weather: "",
  website: "網址",
  wechat_pay: "",
  wednesday: "週三",
  week: "",
  weekly: "",
  weight: "",
  weight_analysis: "",
  weight_gain_analysis: "",
  welcome: "",
  welcome_login: "歡迎登錄",
  welcome_to: "",
  west_northwest: "西偏北",
  west_southeast: "西偏南",
  we_detected_that_you_are_currently_using_mobile_data_for_the_dow:
    "檢測到您當前正在使用流量進行下載，是否繼續",
  when_setting_a_shielded_area_for_a_specific_period_the_valid_tim:
    "屏蔽區域設置為期限時，有效時間不能為空",
  whether_there_are_other_hotspots_with_the_same_name_around_the_d: "",
  whether_the_hotspot_name_matches_the_device: "",
  whether_the_mobile_hotspot_is_turned_on: "",
  whether_to_del_sel: "是否刪除所選項目",
  white_brick: "白磚",
  white_hot: "白熱",
  wifi: "",
  wifi_characters: "",
  wifi_image_transmission: "",
  wifi_information_setting_failed: "",
  wifi_modified_restart: "",
  wifi_modified_successfully: "",
  wifi_modified_successfully_the_device_needs_to_be_restarted_to_t: "",
  wifi_must_be_enabled_on_the_device: "Wi-Fi必須通過設備打開",
  wifi_name: "",
  wifi_name_cannot_be_longer_than_32_chars: "",
  wifi_name_too_short: "",
  wifi_password: "",
  wifi_password_too_short: "",
  wifi_pwd_modified_restart: "",
  wifi_setting: "WIFI設置",
  wind: "",
  wind_direction: "",
  wind_speed: "",
  wind_speed_cloud_map: "",
  wind_speed_m_s: "",
  wind_speed_sensor_status: "",
  wiper: "雨刷",
  wiper_control_exception_pls_check_the_device: "雨刷控制異常，請檢查設備",
  wireless_device: "無線設備",
  wlan: "WLAN",
  wlan_hotspot_switch: "熱點開關",
  wood: "木材",
  wool: "羊毛",
  write: "寫入",
  write_files_to_the_phone_memory: "App會向手機存儲寫入圖像和視頻檔",
  wrong_password_attempts_left: "密碼錯誤,還有N次嘗試機會",
  xsentry_main_server_status: "XSENTRY伺服器1狀態",
  xsentry_secondary_server_status: "XSENTRY伺服器2狀態",
  xxx_inspection_task_failed_to_resume_execution_due_to_network_co: "",
  xxx_inspection_task_failed_to_re_execute_due_to_network_connecti: "",
  xxx_inspection_task_issuance_failed_xxx_robot_not_responding: "",
  xxx_inspection_task_issuance_failed_xxx_robot_points_do_not_matc: "",
  xxx_inspection_task_issued_successfully: "",
  xxx_inspection_task_issuing: "",
  xxx_inspection_task_is_resuming: "",
  xxx_inspection_task_is_re_executing: "",
  xxx_inspection_task_resumed_successfully: "",
  xxx_inspection_task_re_executed_successfully: "",
  xxx_inspection_task_re_execution_failed_xxx_robot_did_not_respon: "",
  xxx_inspection_task_terminated_successfully: "",
  xxx_inspection_task_terminating: "",
  xxx_inspection_task_termination_failed_network_connection_error: "",
  xxx_inspection_task_termination_failed_xxx_robot_not_responding: "",
  yacht: "遊艇",
  yaw_angle_offset: "轉角偏移量",
  year: "年",
  year_month: "",
  yes: "是",
  yesterday: "昨天",
  your_access_is_too_frequent_pls_retry_after_30_seconds:
    "您的訪問過於頻繁，請30秒後重試",
  you_can_enter_1_32_characters_including_digits_letters___and_or:
    "允許輸入1~32位的數字、字母、-、_",
  you_can_enter_8_16_characters_including_digits_letters___and_or:
    "允許輸入8~16位的數字、字母、-、_",
  you_can_upgrade_in_device_information_check_for_updates:
    "可在設備資訊-檢查更新中進行升級",
  you_have_not_completed_the_company_information: "",
  you_need_to_enable_location_services_to_discover_new_devices:
    "需打開定位才能發現新設備",
  you_need_to_turn_on_bluetooth_to_discover_new_devices:
    "需要打開藍牙才能發現新設備",
  zeroing_config_unit: "",
  zeroing_distance: "",
  zeroing_weather: "",
  zoom: "變倍",
  zoom_level: "縮放級別",
  zoom_out: "縮小",
};
